import { agentsApiUrl, apiURL, scriptURL, stripeKey } from 'src/appConfig';
import { API } from './API';
import { isLocalSeoUser } from './FunctionHelper';

const isLocalSeo = isLocalSeoUser() || null;
export const SEOSpaceLocal = 'SEOSpace Local';
export const paths = {
  siteAudit: '/site-audit',
  seoTasks: '/seo-tasks',
  externalScans: '/external-scans',
  userManagement: '/user-management',
  settings: '/settings',
  billing: '/billing',
  price: '/price',
  plan: '/plan',
  signup: '/signup',
  signin: '/signin',
  forgot: '/forgot',
  google: '/google',
  memberSignup: '/member-signup',
  leadGeneration: '/lead-generation',
  leads: '/leads',
  keywordResearch: '/keyword-research',
  keywordOverview: '/keyword-research/keyword-explorer',
  orbitAiAgent: '/orbit-ai-agent',
  keywordAssist: '/orbit-ai-agent/keyword-assist',
  contentStrategy: '/orbit-ai-agent/content-strategy',
  blogPostAgent: '/orbit-ai-agent/blog-post-agent',
  competitorAnalysis: '/keyword-research/competitor-analysis',
  blogPostIdeas: '/keyword-research/blog-post-ideas',
  keywordsLists: '/keyword-research/keywords-lists',
  reviewAutomation: '/orbit-ai-agent/review-automation',
  onBoarding: '/on-boarding',
  // squareSpaceConnectUtm: '/squarespace-connect?utm=squarespace_market'
  squareSpaceConnectUtm: '/squarespace-connect?via=sqsp',
  squareSpaceConnectOnBoarding: '/squarespace-connect?via=on_boarding',
  statusCheck: '/status/check',
  dashboard: '/dashboard',
  scannedPages: '/scanned-pages',
  blogPost: '/keyword-research/blog-post-ideas',
  squarespaceAuth: '/squarespace-auth',
  keywordTracking: '/keyword-research/keyword-tracking',
  otherTools: '/local-seo',
  backlinkPage: '/backlinks',
  //backlinkPage: '/local-seo/backlinks',
  localChecker: '/local-seo/business-profile',
  googleBusiness: '/google-business',
  mapRankTracker: '/local-seo/map-rank-tracker',
  localTasks: '/local-seo/tasks',
  googleReviews: '/local-seo/google-reviews',
  businessPosts: '/local-seo/business-posts',
  listingManager: '/local-seo/listing-manager',
  citationBuilder: '/local-seo/citations',
  //Old signup with local seo route
  signupLocalSeoExt: '/signup?via=localseo',
  signupLocalSeo: '/signup?via=localsignup',
  trySeoSpace: '/try-seospace',
  squareSpaceConnectUtmLocalSeo: '/squarespace-connect?via=localseo',
  googleReviewsWidget: '/local-seo/google-reviews/widgets',
  googleReviewsEmbed: '/local-seo/google-reviews/embed',
  viewAllSites: '/dashboard/sites',
  localSeoBusinessListRoute: '/local-seo/business-profile/all',
  localSeoBusinessList: '/local-seo/business-profile',
  aiVisibility: '/ai-visibility',
  invitation: '/invitation',
  citation: '/local-seo/citations',
  citationWaitingList: '/local-seo/citation-waiting-list',
  pdfBuilder: '/reports/pdf',
  localSeoAi: '/orbit-ai-agent/local-seo-ai',
  orbitAiAddon: '/orbit-ai-addon',
  contentPlan: '/orbit-ai-agent/content-plan'
};

export const keywordResearchSubmenuTitles = {
  keywordAssist: "Keyword Assist",
  contentStrategy: "Content Strategy",
  contentPlan: "Content Plan",
  keywordOverview: 'Keyword Explorer',
  keywordTracking: 'Keyword Tracking',
  competitorAnalysis: 'Competitor Analysis',
  blogPostIdeas: 'Blog Post Ideas',
  blogPostAgent: 'Blog Post Agent',
  keywordsLists: 'Keywords Lists',
  keywordResearch: 'Keyword Research',
  reviewAutomation: 'Review Automation',
  addKeywords: 'Add Keywords'
};

// APP API Url
export const API_URL: string = apiURL;
export const AGENT_API_URL: string = agentsApiUrl;

// Stripe API key
export const STRIPE_KEY: string = stripeKey;

// stripe message
export const PaymentSuccess: string = 'Subscription confirmed!';
export const PaymentMsgTitle: string = 'Payment Messages';
export const Success: string = 'Success';
export const SuccessFull: string = 'Successful!';
export const FreeTrialSuccessFull: string = 'Free Trial Successful!';
export const FreeTrialSuccessFullDesc: string =
  'Thank you for starting your free trial - continue to improve your Squarespace SEO!';
export const PaymentSuccessDesc: string =
  'Payment successful! Thanks for choosing SEOSpace.';
export const PaymentSuccessMsg: string =
  'You have successfully purchase your subscription';
export const Failure: string = 'Failure';
export const UnSuccessful: string = 'Payment Unsuccessful';
export const PaymentFailed: string = 'Subscription failed!';
export const PaymentFailedDesc: string =
  'Unfortunately, your payment could not be processed at this time. Please check your payment details and try again or contact support.';
export const PaymentFailMsg: string =
  'Your payment was not successfully done, please try again.';

export const currentYear = new Date().getFullYear();

export const helpText: string = "Haven't got an account?";
export const chromeExtensionLink: string =
  'https://chrome.google.com/webstore/detail/seo-space/jdpdpdkkofoclmgbopofhlmoikpfamao';
export const downloadPluginMessage = 'Download Chrome Plugin';
export const chromeExtensionMessage =
  'Before getting started, install the SEOSpace plugin from the Chrome store using the button below. Please refresh this page once plugin is installed.';
export const downloadPlugin = 'Install Plugin';

// introVideo
export const introVideoLink =
  'https://www.loom.com/embed/cc9a8731d57346a7824fe8c0cb798a15';
// add Site Text message
export const addSiteText: string =
  'Visit a Squarespace website and use the plugin to add it to your slot. Once added, you can revisit and reload the dashboard to track SEO progress.';
export const addSiteLearnMore: string =
  'https://www.loom.com/share/f3b0691834804725bedce76359b7c854';
export const LocalSEOPaymentSuccessDesc: string = `Payment successful! Thanks for choosing Local SEO.`;

// API Routes
export const addSiteInDashboardText: any = {
  filterFieldRegex: /[^0-9]/g,
  // specialCharRegex: /[!@#$%^&*()_+=\-<>?/:;"'{}\[\]]/,
  specialCharRegex: /^(?![A-Za-z0-9]+$)[!@#$%^&*()_+=\-<>?\/:;"'{}\[\]\\|]+$/,
  keywordResearchUrlPattern:
    /^(https?:\/\/)?(www\.)?[\da-z.-]+\.[a-z]{2,20}(\/.*)?$/i,
  notSquarespaceUrl:
    "This doesn't seem to be a Squarespace site. Please try again.",
  notAddsite: 'Enter a valid URL',
  alreadyAddedSite: 'You have already added this site.',
  // Old regex for the backup
  // urlRegex: /([\da-z\.-]+)\.([a-zA-Z]{2,20})([\/\w\.-]*)*\/?/g,
  urlRegex: /([\da-z\.-]+)\.([a-zA-Z]{2,20})([\/\w\.-]*)*\/?/gi,
  urlValidation: /^(https?:\/\/)?(www\.)?[\da-z\.-]+\.[a-z]{2,20}\/?$/i,
  leadFormUrlRegex:
    /^(https?:\/\/)?(www\.)?[\da-z\.-]+\.[a-z]{2,20}(\/[\w\.-]*)*(\?[\w%&=-]*&?email=[\w.%+-]+@[a-z\d.-]+\.[a-z]{2,20})?(#[\w\.-]*)?$/i,
  keywordUrlValidation:
    /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?((?!-)[a-zA-Z0-9-]+(?:(?:\.[a-zA-Z]{2,})+))(?::\d{2,5})?(?:\/[^\s]*)?$/,
  notValidUrl:
    'Ensure this is a Squarespace URL with nothing after the / (for example, https://example.com/)',
  pageRemovedDraftMsg:
    'The page you tried to scan might be draft or password protected. To scan draft or password protected, upgrade to the Expert Plan and scan directly from the Squarespace editor.',
  page404ErrorFreeOrDiy:
    'We have detected this site might be a draft or an expired domain. Upgrade to the Expert or Pro Plan to scan draft pages and scan directly from the Squarespace editor.',
  page404ErrorPro: `We have detected this site might be a draft or an expired domain.  Scan directly from the Squarespace editor using SEOSpace's plugin to scan draft pages.`,
  page429Error:
    'We have faced an issue accessing your site due to a temporary issue from Squarespace - please try again later.',
  sqspSiteWelcomeMessage: `Welcome to SEOSpace - we’ve automatically begun scanning your homepage. Once the scan is complete, click “View Scan” to see your results from our extension. Click “Scan Webpage” to scan other pages on your website.`,
  sqspSiteThankYouMessage: `Thanks for connecting your Squarespace website - SEOSpace has automatically begun scanning your homepage. Once the scan is complete, click "View Scan" to see your results and "Scan Webpage" to scan another page.`
};

// total number of section
export const totalNumberChecks: number = 9;

// User registration page
export const SEOSpaceMessage =
  '“SEOSpace - “The Yoast for Squarespace”. A jargon-free, easy-to-use SEO plugin that gives you step-by-step recommendations to rank your Squarespace site higher on Google. Proven to increase organic traffic by up to 68% in 2 months.”';
export const SEOSpaceCEOName = 'Henry Purchase';
export const SEOSpacePosition = 'CEO and Founder of SEOSpace';
export const assetDesignTopPath = '/static/images/logo/Asset1.svg';
export const assetDesignBottomPath = '/static/images/logo/Asset2.svg';
export const avatarIconLogo = '/static/images/avatars/Icon.svg';
export const logoWithBackground = '/static/images/logo/logo.svg';
export const logoWithoutBackground = '/static/images/logo/logo-inverted.svg';
export const tickIcon = '/static/images/icons/tickIcon.svg';
export const joinWithGooglebtn = 'Join with Google';
export const joinWithFacebookbtn = 'Join with Facebook';
export const LoginWithSquareSpaceBtn = 'Login with Squarespace';
export const joinWithSquareSpaceBtn = 'Join with Squarespace';
export const connectWithSquareSpaceBtn = 'Connect with Squarespace';
export const disconnectWithSquareSpaceBtn = 'Disconnect with Squarespace';
export const userRegisteredSuccessfully = 'You have successfully registered';
export const continueWithSquareSpace = 'Continue with Squarespace';

// User login page
export const loginHelmet = 'SEOSpace - SignIn';
export const loginBackgroundPath = '/static/images/login/loginbackground.svg';

// User forget password
export const goBackToLogin = 'Back to Create Account';
export const passwordResetOnMail =
  'Password resent Link has been sent to your mail';
export const passwordRestSuccessfull = 'Password Reset Successfull';

// Add Scan Modal
export const addScanModalDescription =
  'Add the URL of a Squarespace webpage to run a scan. Once completed, press “View Scan” to see results for that webpage.';
export const runScanBtn = 'Run Scan';
export const runPremiumScanBtn = 'Add Keyword';
export const scanWithKeyword = 'Scan with a Keyword';
export const advanceSettingBtn = 'Advanced Settings';
export const scanWebpage = 'Add a Web Page to Scan';
export const addScanWebpage = 'Scan Webpage';
// Site Audit Modal
export const siteAuditModalDescription =
  'After adding your website, we will automatically scan every page to give you an SEO score, with personalized recommendations.';
export const runRunBtn = 'Run';
export const runSkipBtn = 'Skip';
// export const advanceSettingBtn = 'Advanced Settings';

// Scan dashboard
export const previousScanlabel = 'Add a Site Audit';
export const websiteAudit = 'Website Audit';
export const addScan = 'Add Scan';
export const siteAudit = 'Site Audit';
export const dashboard = 'Dashboard';
export const webUrl = 'Webpage URL';
export const score = 'Score';
export const keyword = 'Target Keyword';
export const keywordCompare = 'Keyword Volume';
export const wordCount = 'Word Count';
export const date = 'Date';
export const scanView = ' View Scan';
export const addNewChecks = 'Add a New Check';
export const yourSiteScan = 'Your Site Scans - roughwatermedia.com';
export const monthlyScanUse = 'monthly scans used';
export const availableScanUse = 'website slots used';
export const availableSearchUse = 'searches used';
export const availableKeywordsUse = 'keywords tracked';
export const getMoreScan = 'Get more Scans';
export const GetMoreSiteSlots = 'Get more slots';
export const GetMoreSearches = 'Get more searches';
export const averageSEOScore = 'Average SEO Score';
export const averageSEOScoreChange = 'Average Change in SEO Score';
export const comparison = 'Change since last scan';
export const comparisonTooltip =
  'This change shows the difference in SEO score between your two most recent scans to show you how your score is improving.';
export const deleteSiteScan = 'Are you sure you want to delete the scan of ';
//profile page
export const profileMainTitle = 'Your Profile';
export const AccountDetails: string = 'Account Details';
export const DateFormat: string = 'Date Format';
export const ChangePassword: string = 'Change Password';
export const DeactivateAccount: string = 'De-Activate Account';
export const DeactivateAccountText: string =
  "We're sorry to see you go! Feel free to get in touch if there's anything we can do better. Once you deactivate your account, you won't be able to access your account or the plugin.";
export const BecomeAffiliate: string = 'Become an affiliate';
export const AffiliateScheme: string = 'Affiliate Programme';
export const AffiliateText = {
  first:
    'Grow your business and earn extra income with us. Spread the word about SEOSpace and receive a ',
  second: '25% recurring commission ',
  third:
    'for every sale you make.Our programme also includes a 60-day cookie and real-time reporting.'
};
export const launchAccount: string = 'Launching 2nd May';
export const ManageAccount: string = 'Manage Affiliate';
export const BecomeAccount: string = 'Become an affiliate';
export const deActiveAccountText =
  'Please provide feedback on why you want to deactivate your account - this will allow us to improve our product for the Squarespace community.';
export const deActiveAccountPopUpText: String =
  'SEO isn’t a one-and-done - you understand that SEO requires constant improvement and iteration over the long-term to get results?';
export const deActivateAccountButton: string = 'I understand';
export const freePlanDowngradeText: string =
  'Downgrade to the free plan and lose premium insights?';
export const freePlanDowngradeButtonText: string = 'Lose premium insights';
export const freePlanDowngradeCancelButtonText: string = 'Stay on ';
export const freePlanDowngradeCancelButtonTextForDeactivate: string =
  'Continue improving my SEO';
//Get More Scan page
export const billingMainTitle = 'Billing';
export const agencyPlanName = 'Expert Plan';
export const agencyPlanTitle =
  'SEO expert in your pocket without years of study.';
export const changePlan = 'Change Plan';
export const monthly = 'Monthly';
export const addOnsMainTitle = 'Get More Scans';
export const addOnsText =
  'Ran out of scans? You can buy 50, 100, 250 or 500 more scans using the buttons below. These scans are a one-off purchase and will automatically be applied to your account.';
export const fiftyScans = '+50 Scans';
export const fiftyScansText =
  'Buy a one-off additional 50 scans to be added to your account.';
export const fiftyScansTextsec =
  'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.';
export const hundredScans = '+100 Scans';
export const hundredScansText =
  'Buy a one-off additional 100 scans to be added to your account.';
export const hundredScansTextsec =
  'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.';
export const twoHundredFiftyScans = '+250 Scans';
export const twoHundredFiftyScansText =
  'Buy a one-off additional 250 scans to be added to your account.';
export const twoHundredFiftyScansTextsec =
  'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.';
export const fiveHundredScans = '+500 Scans';
export const fiveHundredScansText =
  'Buy a one-off additional 500 scans to be added to your account.';
export const fiveHundredScansTextsec =
  'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.';
export const addOneScanUse = 'scans used';
export const alreadyPurchasedButton = 'Already Purchased';
export const buyNowButton = 'Buy Now';
export const paymentTitle = 'Payment Method';
export const paymentText = 'Change how you pay for your plan.';
export const editPayment = 'Edit Payment Method';
export const addPayment = 'Add Payment Method';
export const subscriptionExpired =
  'Your subscription is expired please renew your subscription';
export const addAddOns =
  'Your subscription scan is completed please add add-ons';
export const checkKeyword = 'Please add keyword';
export const newAddAddOns = 'Your add-ons scan is completed please new add-ons';
export const successScanMessage = 'Successfully scan your site';
export const scanProgressMessage = 'Your page scan is in progress.';
export const selectCountry = 'Please select country';
export const upgradePlanMessage = 'You have successfully upgraded your plan';
export const downgradePlanMessage =
  'You have successfully downgraded your plan';

export const scheduleMessage = {
  scheduleMessageOne: 'You have downgraded your plan from',
  scheduleMessageTwo: 'plan. Your current plan will remain active till',
  localSeoCancelMessage:
    'Your Local SEO plan is canceled and will remain active until',
  subscriptionCancelMessage:
    'Your subscription is canceled and will remain active until'
};

// Payment page
export const freePlan = 'Free Plan';
export const perMonth = 'per month';
export const subscribe = 'Subscribe';
export const planIncludes = 'This includes:';
export const planPrice = '$0.00/site/month';
export const downGradePlanFeedback =
  'To help us improve, please share one thing we could improve/change to make SEOSpace a no-brainer to not cancel.';

// Addon page
export const completed = 'completed';
export const freePlanDialogTextFirst = 'FREE PLAN: ';
export const freePlanDialogTextSec =
  'Want to rank above the competition and access personalised recommendations? Upgrade to our DIY or Expert plan today.';
export const goPremium = 'Upgrade Plan';

// Affiliates links
// export const affiliatesLink = 'https://seospace.getrewardful.com/signup';
export const affiliatesLink = process.env.REACT_APP_AFFILIATE_INVITE_URL;
export const affiliatesLinkLocalSeo = 'https://seospace.getrewardful.com/signup?campaign=seospace-local';
export const AFFILIATE_COOKIE_NAME = "_gr_id";
export const SEO_AFFILIATE_COOKIE_NAME = "_gr_affiliate";

// Login message
export const successfulLogin = 'Successfully logged in';

// Scan List view
export const needsWork = 'Needs Work';

// New addon text
export const buyAddonFirst = 'Buy a one-off additional ';
export const buyAddonFirstSecond = ' scans to be added to your account.';
export const goToDashboard = 'Go to my dashboard';
export const getStarted = 'Get started';
export const addOnFail = 'Addon failed!';
export const tryAgain = 'Try again';
export const contactSupport = 'Contact Support';
export const supportText = 'Support';

// Logout text
export const logoutTitle = 'Log Out';
export const logoutText = 'Are you sure you want to log out?';

//Plan
export const freePlanTitle =
  'Run out of scans or want to beat the competition through our premium features? Update below today.';
export const diyPlanTitle =
  'Traffic light SEO checker for solopreneurs & bloggers.';
export const planChangeText = 'Upgrade from ';
export const plan = ' PLAN';
export const downgradeMessage = 'and lose access to premium insights';
export const upgrade = 'Upgrade';

// Reset Password
export const resetPasswordText =
  'Enter your email to receive a link to change your password. Please check your spam.';

export const freeAffiliateText: string =
  "Can we grey out the affiliate if they're on the free plan? I don't think it makes sense to access affiliate programme if they're not on a paid plan.";

// Logout Link
export const logoutLink = 'https://www.seospace.co/squarespace-seo-plugin';

// Signup Score
export const notSEOWebsite = 'This is not a Squarespace website';
export const wayToIncreaseTraffic =
  'We have found some ways to improve your web traffic';
export const percentageSquarespaceweb =
  'SEOSpace’s Squarespace SEO plugin is proven to increase your visibility and web traffic by up to 68% in 2 months.';
export const ahrefsUrl = 'https://ahrefs.com/blog/squarespace-seo/';
export const signupScoreVideo = 'https://www.youtube.com/watch?v=COofysYPW18';
export const signUptoBePart = '- sign up to be part of the ones that do.';
export const insertedScoreMessage = `Your SEO score is `;
export const insertedScoreSecondMessage = `%. Sign up to use our Squarespace SEO plugin to get step-by-step guidance on how to improve your score and rank higher on Google.`;
export const insertedScoreThirdMessage =
  ', the leading Squarespace SEO experts.';
export const congratulationPassAllTest =
  'Congratulations, you passed all checks!';
export const weFound = 'But we found';
export const additionalOptimization = '6 additional optimizations';
export const importantSEOMessage = `You already know that SEO is important for your website's success. Now you can find out how your website measures up with SEO checklist. Instantly, you'll can get a report on how your website is performing and what areas need improvement`;
export const signupAndAccesToSEO =
  'Sign up now and get instant access to your SEO report and unlock the potential of your website';

// Add payment method
export const requireCardDetailsMessage =
  ' We need you to enter your card details again to migrate your existing subscription. Since we do not store any card related data, we cannot migrate it from our old system.';

// Add on sucess message
export const scansAdded: string = 'Scans added';
export const moreScanSuccess: string =
  'You have successfully purchased more scans.';

// Guide Modal
export const modalGuideText = {
  getStart:
    'Welcome to SEOSpace - before getting started, watch these tutorials and check your email to sign up to our community. This is where you will access support and provide feedback. The invite email will come from “Circle.so” - our community platform.',
  installOne: {
    first: 'Once you’ve watched these videos, install our',
    link: ' Squarespace SEO plugin',
    second:
      ' via the Chrome store. Once done, revisit and add the SEOSpace dashboard to your bookmarks - you’ll need it to make the most of our plugin.'
  },
  support: `All support is done via the SEOSpace community. Check your email inbox to signup via Circle to access it. Once signed in, you can access the community from the bottom right-hand widget on the SEOSpace dashboard. You will also find all plugin tutorials, SEO courses and groups specific to your plan here`,
  scan: `Visit any Squarespace website (either a live site or on the Squarespace dashboard) and click on the plugin from the bottom right-hand side of your screen. Then click scan to start getting recommendations of things to change to improve your SEO.`,
  improve: `Using the Squarespace editor, make changes to your site following the plugin’s recommendations and rescan once completed to ensure all the best practices are followed.`,
  openPlugin: `Visit any Squarespace website (either a live site or on the Squarespace dashboard) and click on the plugin from the bottom right-hand side of your screen. Then click scan to start getting recommendations of things to change to improve your SEO.`,
  reScan:
    'Once you have made and saved your changes on the Squarespace editor, you can rescan your web page to ensure it has been optimised and track your improvements over time using the dashboard.'
};

export const onBoardingVideoLink = {
  getStart: 'https://www.loom.com/embed/9027201cc26b492cb55bc58d5b695d9b',
  installOne: 'https://www.loom.com/embed/06c460a09b6e40229dbef78741a08402',
  openPlugin: 'https://www.loom.com/embed/96ec85f5f288481fa50e18c333b9cbc7',
  improve: 'https://www.loom.com/embed/a910f01cf06e447aa1b7e41e52f03b89',
  reScan: 'https://www.loom.com/embed/9fe6387498c247e78c5a4b479d825bc5'
};

// Analaytics Dashboard
export const webAnalytics = 'Your analytics';
export const tableHeaderTitle = {
  webUrl: 'Website Pages',
  clicks: 'Clicks',
  impression: 'Impressions',
  seoScore: 'SEO Score',
  changeInScore: 'Change in score since first SEO scan',
  avgPosition: 'Average Position'
};
export const employmentLifeSrc = '/static/images/analytics/employee-life.svg';
export const analyticsWebNotFound = {
  nothingHere: 'Nothing to see here!',
  analyticsWebNotFoundMessage: `To see analytics please connect google analytics`
};
export const topKeywordTable = {
  keyword: 'Keyword',
  volume: 'Volume'
};

export const changelogTable = {
  event: 'Event',
  user: 'User',
  from: 'From',
  to: 'To',
  date: 'Date',
  traffic: 'Traffic Increase'
};
export const insight = {
  seoInsight: 'SEOSpace Insights',
  keywordChoice: 'Keyword Choice',
  keywordChoiceMessage: ` Keyword optimization is a crucial aspect of search engine
  optimization (SEO) as it helps to improve a website's
  visibility and ranking in search engine results pages
  (SERPs). When optimizing a website, it's important to
  choose keywords that are relevant to the content on the
  site and are frequently used by the target audience. We
  have detected your target keywords aren't getting enough
  traffic, it may indicate that they are too broad or
  competitive, and the website may not rank well for them.
  It's advisable to either narrow down the keywords or use
  long-tail keywords, which are more specific and less
  competitive, some of these keywords are:`,
  backLink: 'Backlinks',
  backLinkMessage: ` Backlinks Backlinks are an important aspect of SEO, as
  they help to improve a website's visibility and ranking in
  search results. Having high-quality backlinks from
  reputable websites can increase a website's credibility
  and authority, leading to better search engine ranking.
  Downloading a list of backlinks can help you assess your
  website's backlink profile and identify areas for
  improvement. Click the button below to download your
  backlinks report now.`,
  banckLinkBtn: 'Get Backlink Report',
  contentLength: `Content Length`,
  contentLengthMessage: `Content length is an important factor to consider in SEO, as it affects both user engagement and search engine rankings. Longer content is typically preferred by search engines as it provides more information to the user. However, it's important to strike a balance between content length and quality. Too much fluff or low-quality content can negatively impact user experience and lead to a drop in search rankings. Aim for well-researched, high-quality content that is both informative and engaging for your target audience. Your competitors have a content length of between 123 and 2440 words. You need to write more than 1,234 words for the best SEO. Your content has 800 words.`
};

// Auth Google
export const googleAuthMessage =
  'Connect SEOSpace with Google Search Console to access unique insights and rank your site higher on Google.';
export const googleAuthNewMessage =
  "Connect SEOSpace to Google Search Console for unique insights to help your site rank higher on Google. If you're unsure how to set it up, watch this tutorial";
export const GscAuthSuccesMessage =
  'You have successfully connected SEOSpace to Google Search Console - return to the SEOSpace dashboard to complete the site-wide SEO audit.';
export const authSuccesMessage =
  'You have successfully connected SEOSpace to Google Search Console - continue to watch a tutorial on how to make the most out of our plugin and dashboard.';
export const insightGSCSuccessMessage =
  'You have successfully connected Google Search Console - return to the insights dashboard and check the sites details.';
export const connectGoogleBtn = 'Connect Google Search Console';
export const IndexedTutorial = 'https://www.youtube.com/watch?v=rhIEFR7x7q4';
export const IndexedNewTutorial =
  'https://www.youtube.com/watch?v=7bKsHsi7op0&list=PLlaoclvOMRPyFA6ylbOSMH3-0Ah3txns4';

export const removeSiteTitle = 'Delete Website';
export const removeSiteMessage =
  // 'Please confirm you want to delete this site from your scans';
  'Are you sure you want to delete your website from SEOSpace?';

export const removeMonitoring =
  'Please Confirm you want to remove monitoring from Site Audit.';

export const stopAudit = 'Please confirm that you want to stop the site audit.';
export const upgradePlanForSiteAudit =
  'You have filled up all of your site slots. To add a new site, please upgrade your plan or remove an existing site from a slot.';
export const updateFields =
  'Please share a little bit more detail about your business so we can improve your SEOSpace experience.';
export const skipUpdateFields = 'Are you sure you want to skip this process?';
export const removeSites = 'You have to remove site audits to continue.';
export const reAudit = 'Please confirm that you want to reaudit site.';
export const gscReauditText = 'Do you want to reaudit since you connected GSC?';

// Sidebar
export const supportMessage = 'Prefer email support? Reach out to';
export const supportEmail = 'support@seospace.co';

// Insights
export const insights = {
  seoInsights: 'SEO Insights (BETA)',
  yourSiteInsight: 'Your Site Insights -',
  googleTrafficDecrease:
    'Your web traffic from Google has decreased since last month.',
  addPost: ' Add more blog posts',
  addMorePost: ' You need to add more blog posts on your ',
  generateBlog: 'You can generate your blog with AI',
  optimizeWebsite: 'Optimize you website',
  scoreMessage: '  Your average score across the ',
  reScanMessage: '%. Rescan the below pages to improve your SEO score.',
  reScanOtherMessage: '%. Start increasing the threshold by 10%.',
  addBackLinks: 'Add more backlinks',
  backLinkMessage: {
    first: `Backlinks are the fuel to our SEO growth. Watch our `,
    second: ` to increase the number of high-quality backlinks your website has.`
  },
  goTutorial: 'backlink-building tutorial',
  recommendedPage: ' Recommended pages to scan',
  belowRecommendation: `Below are the pages we recommend you scan and improve to
  maximise traffic growth: (BETA)`,
  GSCNotConnected: `Google Search Console (GSC) is not connected for this particular website.
  Please connect GSC to this plugin to get personalised recommendations.`,
  noScan: `You haven't added any sites to scan. Please add a site from the dashboard and then see its insights after 28 days.`,
  clickHere: '/site-audit',
  insightReleaseLable: ' Prefer email support? Reach out to',
  insightTrafficWebsite: 'Last 2 months traffic on the website:',
  recommendInfo: `These pages have been selected as they have high impressions but a low click-through rate based on Google Search Console data. I.e. they're ranking for potentially high-volume keywords, but no one is clicking on them as they're ranking low. Scan and improve these pages to rank higher on search engines.`,
  insightScoreGreaterMessageOne:
    'Your organic website traffic has grown by >20% in the past 28 days. Remember, SEO isn’t a “one and done” - follow the below recommendations and watch our ',
  insightScoreGreaterMessageSecond: 'SEO 101 course',
  insightScoreGreaterMessageThird: ' to ensure your traffic converts.',
  SEO101Course: 'https://community.seospace.co/c/introduction-to-seo/',
  addMoreBlogeTextScoreGreaterOne:
    'Yes - whether we like it or not, websites need blogs to grow.',
  addMoreBlogeTextScoreGreaterVideo:
    'https://www.youtube.com/watch?v=-ATU9l9NDdw',
  WatchVideo: 'Watch this video',
  addMoreBlogeTextScoreGreaterSecond:
    ' to learn the method we recommend for adding blogs to a website.',
  addMoreBlogeTextScoreMediumOne:
    'Your website traffic has grown slightly over the past 28 days. Accelerate it further and attract target customers by adding search engine-optimised blog posts to your website. ',
  addMoreBlogeTextScoreMediumVideo:
    'https://www.youtube.com/watch?v=-ATU9l9NDdw',
  addMoreBlogeTextScoreMediumSecond:
    ' to learn how we recommend structuring your website and adding blogs to it to grow traffic.',
  personalizedMessage:
    'Personalized recommendations to help improve your SEO and grow your website traffic - available 28 days after the first scan you complete on a website.'
};

// export const hireUsLogo = '/static/images/sidebaricon/bag.svg';
export const hireUsLogo = '/static/images/newSidebarIcon/bag.svg';
export const seoAcademyLogo = '/static/images/newSidebarIcon/seoacademy.svg';
export const launchIcon = '/static/images/newSidebarIcon/launch.svg';
export const hireUs = 'Hire Us';
export const seoAcademy = 'SEO Academy';
export const hireUsLink = 'https://www.seospace.co/get-in-touch';
export const seoAcademyLink = 'https://www.seospace.co/squarespace-seo-course';
export const subscribeText =
  'Your subscription seems to have been expired. Please subscribe again.';
export const memberSubscribeText =
  'Your admin subscription seems to have been expired. Please contact the admin.';
export const sevenDayFree = 'Free 7-day trial';
export const stripeStatusTrial = 'trialing';
export const showAIBlogTitleDes = `These blog titles and keywords are generated by AI, based upon what
you currently rank for. Only use these as a starting point for
research - do not blindly use them without considering your broader
SEO strategy.`;

export const communityLink = 'https://community.seospace.co/c/public/';
export const tutorialsLink =
  'https://community.seospace.co/c/product-tutorials/';
export const tutorialLink =
  'https://www.youtube.com/watch?v=bnCdYkhb-hE&list=PLlaoclvOMRPyFA6ylbOSMH3-0Ah3txns4';
export const bugReportLink = 'https://forms.gle/ptU6Y3qqBJcYkogF6';
export const accessDeniedErrorSQAP = {
  first:
    "There has been an error logging in via Squarespace - potentially because of your Squarespace account permissions. If you don't have an SEOSpace account, please create one using your email and password. If you have an SEOSpace account already linked to Squarespace, please ",
  noConnectionError: `Your Squarespace account isn't linked to an existing SEOSpace account. If you don't have an SEOSpace account, please create one using your email and password. If you have an SEOSpace account already linked to Squarespace, please `,
  noConnectionLocalSeoError: `Your Squarespace account isn’t linked to an existing ${SEOSpaceLocal} account. If you don't have an ${SEOSpaceLocal} account, please create one using your email and password. If you have an ${SEOSpaceLocal} account already linked to Squarespace, please `,
  alreadyConnectedError: `Your Squarespace account is already connected to a different SEOSpace account.
If you don't have an SEOSpace account, please create one using your email and password. If you have an SEOSpace account already linked to Squarespace, please `,
  link: 'contact support.'
};

// export const upgradeWarningPlan =
//   'We have deprecated the free plan feature, so if you wish to access the new feature, you should upgrade to the paid plan, otherwise, you can cancel your subscription';
export const upgradeWarningPlan =
  'Please subscribe to an SEOSpace plan to begin improving your Squarespace SEO - you need an active subscription to access our features.';
export const siteAuditModal: any = {
  scannedPages: 'Scanned Pages',
  previousScans: 'Previous scans',
  healthScore: 'Health Score',
  healthScoreDescription: 'Changes made since first scan for ',
  theAverageSeoScore: 'The average SEO score of',
  allThePages: 'all the pages',
  websiteauditPercentage: '78%',
  websiteauditIncrease: 'Increase',
  websiteauditReAudit: 'Re-Audit',
  topIssues: 'SEO/AIO Tasks',
  topIssuesDes: 'Below is a prioritized list of SEO tasks for',
  topIssuesDescription:
    'Click on a task to view a detailed list of the pages impacted and a step-by-step tutorial on how to fix them.',
  monthlyOrganicTraffic: 'Monthly Organic Traffic',
  numberOfKeyword: 'Number of Keywords',
  numberOfClicks: 'Number of Clicks',
  googleSearchConsole: 'Connect SEOSpace to Google Search Console',
  viewSeoReport: 'View SEO Report',
  seoSpaceSiteAudit: 'SEOSpace | Site Audit',
  siteWide: 'Add your website to start a site-wide SEO audit:',
  removePages: 'Pages to skip during site-wide audit:',
  alertDescription:
    "You can also skip if you'd prefer to explore SEOSpace first, or want to scan a draft or password-protected website using our plugin.",
  lorem:
    'Select the pages you want SEOSpace to skip during the site-wide SEO audit. These might include your contact page, tag or category pages, or your privacy policy page.',
  gscDescription:
    'Connect SEOSpace to Google Search Console to access personalised recommendations and advanced insight to improve your SEO.',
  tutorialDescription:
    'Watch the below tutorial to make the most out of your SEOSpace experience. This short video will answer your FAQs and help you avoid common pitfalls.',
  addPages: 'Add pages',
  addNewUrl: 'Add a New URL',
  add: 'Add',
  makeSureConnectedToGoogleConsole:
    'Please make sure you are connected to Google Search Console.',
  howToConnectGsc: 'How to connect GSC',
  noWebsiteScanned:
    'Currently you don’t have any website scanned. Feel free to start an new Audit',
  yourWebsiteAudit: 'Your website audit for',
  isInProgress: 'is in progress...',
  isCompleted: 'is complete ',
  auditTakes: ' On average,',
  uptominutes: ' audits take up to 10 minutes,',
  note: 'Note: ',
  notifyOnComplete: ' but might take longer for bigger sites. ',
  ifNotify: 'If the site audit progress freezes, please refresh the page.',
  completeNotify: ` Refreshing the site won't lose your audit progress — you’ll get a notification via email once it’s complete.`,
  stopAudit: 'Stop Audit',
  seeResults: 'See Results',
  videoDescription:
    ' While your site-wide SEO audit is in progress, watch this short video to learn how to use SEOSpace.',
  videoLink: 'https://www.youtube.com/embed/ZI3_rXF9e6k?si=TgOZzqXDokpMqZrv',
  progressModuleVideoLink:
    'https://www.youtube.com/embed/Jh2bXiM-SZM?si=3UOo1wZpQ8ukjeQr',
  setUpMonitoring: 'Set up Monitoring',
  generateSeoReport: 'Generate SEO Report',
  compareTo30DaysSeoReport: 'Last Month SEO Report',
  firstAuditSeoReport: 'First Audit SEO Report',
  increasedBy: 'Increased by',
  decreasedBy: 'Decreased by',
  siteAuditAdd:
    'You haven’t added a site to audit - feel free to add your first site.',
  getSeoReport: 'Generate SEO Report:',
  reportDescription:
    'If you’d like to add a Logo, please select the image and upload it below or skip to download an SEOSpace branded PDF:',
  reportNote:
    'Note: Please ensure that you upload a high-resolution image. It should be in PNG format and must not exceed 2 MB in size.',
  delete: 'Delete',
  change: 'Change',
  downloadPdfReport: 'Download Report',
  cropImage: 'Crop Image',
  addLogo: 'Add Logo',
  previewPdf: 'Preview Report',
  reloadPageMsg:
    'If you notice that the progress has stopped, please refresh the page.',
  scannedPagesDescription:
    'From this table, you can view the scores and results of each page within your selected website. To learn how to add scans and view results, ',
  gscIsConnectedText:
    'You have already given SEOSpace permission to connect to Google Search Console, please proceed to the next step.',
  siteProgressLoadingText: `We're preparing to start your audit - you'll see its progress soon...`,
  stuckMessage: `Bear with us... we're just finishing off your SEO audit.`,
  finalStageMessage: `It is taking a bit longer than usual to audit your site, but don’t worry, your results will be with you soon!`,
  reAuditErrorFirst:
    'You have already added this site to a site audit slot - please',
  reAuditErrorLinkText: 're-audit',
  reAuditErrorSec: 'this site instead.',
  no: 'No',
  yesSkip: 'Yes, Skip',
  skipModalDesc: 'Are you sure you want to skip site audit?',
  exceedLimitText: 'You have used up all of your site audit slots - please ',
  viewTasks: 'View SEO/AIO Tasks',
  viewScanResults: 'View Scan Results',
  exceedLimitTextEnd:
    ' your account to access more site slots, or delete a site from within "Actions".',
  generatePdfReport: 'Generate PDF Report',
  pdfIconDesc:
    'Either review the current state of the site or compare it with your first audit to see how changes have occurred over time.',
  currentAudit: 'Current Audit',
  firstAuditBtn: 'Compare with First Audit',
  pdfIconUploadDec:
    'If you’d like to add a Logo, please select the image and upload it below or skip to download an SEOSpace branded PDF.',
  clickAndUpload: 'Click to upload ',
  orDrag: 'or drag and drop',
  imgSizeDesc: 'PNG (max size is 2 MB)',
  skip: 'Skip',
  generatePdf: 'Generate PDF Report',
  pdfProDesc:
    'Choose the report type. The first audit shows changes over time, while the current audit shows only the current state.',
  transferSites: 'Transfer Site',
  cancelTransferSites: 'Cancel Transfer Site',
  enableAi: 'Enable AI Visibility',
  disableAi: 'Disable AI Visibility',
  selectIconTitle: 'Select Custom Icon',
  selectIconDesc:
    'Choose an icon to represent your brand in the PDF. By default, the SEOSpace icon is used, but you can select a custom icon to personalize the report.'
};

export const seoIssuesModal: any = {
  seoIssuesTitle: 'SEOSpace | SEO/AIO Tasks',
  seoIssuesLable: 'SEO/AIO Tasks',
  description:
    'Once you select an SEO task, you’ll see a video tutorial on how to fix it, a step-by-step guide and a list of all the pages impacted. To see the details, click “View Scan” to view the scan results for each page.',
  sections: 'section in Total',
  tutorial: 'Tutorial',
  tutorialDescription: "How to fix the issue with pages that aren't indexed",
  watchTutorial: 'Watch Tutorial (03:10)',
  tutotialLink: 'https://youtu.be/q08PfL_hUmk'
};

export const emailRegex = /^[A-Z0-9.+-_]+@[A-Z0-9.+-_]+\.[A-Z]{2,}$/i;

// Titles to be removed
export const restrictedMenus = ['User Management', 'Billing'];
export const diyRestrictedMenus = ['User Management'];
export const restrictLocalSeoMenus = [
  'Dashboard',
  'Site Audit',
  'Keyword Research',
  'User Management',
  'Billing',
  'Local SEO'
];

// Menu list to show upgrade modal
export const menuListToShowUpgrade = [
  'Site Audit',
  'SEO/AIO Tasks',
  'Keyword Research',
  'Orbit AI',
  'Dashboard',
  'Backlink Analysis',
  'Local SEO'
];

// Menu list to show upgrade modal after AI purchase
export const menuListToShowUpgradeAfterAiPurchase = [
  'Keyword Research',
  'Orbit AI',
  'Backlink Analysis',
  'Local SEO'
];

export const userManagement: any = {
  inviteMembers: 'Invite Team Member',
  userManagement: 'User Management',
  userManagementTitle: 'SEOSpace | User Management',
  userManagementDescription:
    'Manage users by inviting them to access your dashboard. Simply click “Invite Team Member,” and the user can sign up to gain access. ',
  removeUserDescription: 'Please confirm that you want to remove this user.',
  cancelInvitationDescription:
    'Please confirm whether you want to delete this invite or not.',
  deleteSlotDescription:
    'Please confirm whether you want to delete this user’s account.',
  deleteSlotSiteDescription:
    'Note: In this this below list you can delete Audit sites by selecting them.',
  resendInvitationDescription:
    'Please confirm that you want to resend this invitation.',
  inviteModalTitle: "Please enter the email of the user you'd like to invite",
  inviteModalDescription:
    'The invited team member will receive an email with instructions to join your team. Once the invite has been sent, you will billed for the additional user. This user will not be able to view account or billing info of your account.',
  buySlotTitle: 'Buy Seats',
  slotTitleDescription:
    'Expand your team`s capacity by purchasing a slot to add a new team member.',
  priceDescription:
    'Invite and collaborate with team members by purchasing a user seat for ',
  additionalSlotDescription:
    'Once you purchase a seat, you will be able to invite your team from within the “User Management” tab. This will also unlock an additional',
  designerPlanSlotDescription:
    'Each slot provides the thrilling opportunity to unlock three additional scans, seamlessly adding them to your account. This means that for every slot you have, you can enjoy a total of three extra scans.',
  agencyPlanSlotDescription:
    'Each slot provides the thrilling opportunity to unlock three additional scans, seamlessly adding them to your account. This means that for every slot you have, you can enjoy a total of five extra scans.',
  slotMaxLimit: ' You have reached the maximum limit of slots.',
  inviteMembersTitle: 'Invite Team Members',
  tutorialLink: 'https://youtu.be/f2UHf0h8oYs'
};

export const userRoles = {
  member: 'member',
  admin: 'admin'
};

export const ignoredUrls = ['/category', '/tag'];
export const requestIndex = 'Request Indexing';

export const monitoringSetting = 'Automatic monitoring';
export const monitoringDescription =
  'Get automatic updates on whether you need to step in to improve your SEO, Orbit AI and receive personalised recommendations to boost your rankings.';
export const monitoringDescriptionEnterprise =
  'Get automatic updates on whether you need to step in to improve your SEO and receive personalised recommendations to boost your rankings.';

export const scanPageRestriction = {
  diy: {
    pages: 100,
    msg1: 'DIY plan users can audit up to 100 pages in their site audit, please select ',
    msg2: ' URLs to skip. You can add these back individually via "Actions" once the site audit is complete.'
  },
  starter: {
    pages: 100,
    msg1: 'Starter plan users can audit up to 100 pages in their site audit, please select ',
    msg2: ' URLs to skip. You can add these back individually via "Actions" once the site audit is complete.'
  },
  starterplus: {
    pages: 100,
    msg1: 'Starter plan users can audit up to 100 pages in their site audit, please select ',
    msg2: ' URLs to skip. You can add these back individually via "Actions" once the site audit is complete.'
  },
  'starter plus': {
    pages: 100,
    msg1: 'Starter plan users can audit up to 100 pages in their site audit, please select ',
    msg2: ' URLs to skip. You can add these back individually via "Actions" once the site audit is complete.'
  },
  designer: {
    pages: 500,
    msg1: 'Pro plan users can audit up to 500 pages in their site audit, please select ',
    msg2: ' URLs to skip. You can add these back individually via "Actions" once the site audit is complete.'
  },
  pro: {
    pages: 500,
    msg1: 'Pro plan users can audit up to 500 pages in their site audit, please select ',
    msg2: ' URLs to skip. You can add these back individually via "Actions" once the site audit is complete.'
  },
  proplus: {
    pages: 500,
    msg1: 'Pro plan users can audit up to 500 pages in their site audit, please select ',
    msg2: ' URLs to skip. You can add these back individually via "Actions" once the site audit is complete.'
  },
  proPlus: {
    pages: 500,
    msg1: 'Pro plan users can audit up to 500 pages in their site audit, please select ',
    msg2: ' URLs to skip. You can add these back individually via "Actions" once the site audit is complete.'
  },
  'pro plus': {
    pages: 500,
    msg1: 'Pro plan users can audit up to 500 pages in their site audit, please select ',
    msg2: ' URLs to skip. You can add these back individually via "Actions" once the site audit is complete.'
  }
};

export const billingTexts = {
  paymentMethodNotAdded: 'You have not added a payment method',
  cancelSubscriptionWarning:
    'Are you sure you want to cancel your subscription?',
  linkPaymentText: 'The payment has been made through link'
};

export const yes = 'Yes';
export const cancel = 'Cancel';
export const save = 'Save';
export const actions = 'Actions';
export const watch_tutorial = 'Watch Tutorial';
export const noDataFound = 'No data found';
export const oops = 'Oops';

export const changePlanText = {
  pricing: 'Pricing',
  pricingDescription:
    'Simple pricing plans that you can start or cancel at any time.',
  monthly: 'Monthly',
  billedMonthly: 'Billed monthly',
  billedAnnually: 'Billed annually',
  annually: 'Annually',
  planTimeline: '/mo',
  subscribed: 'Subscribed',
  buySeat: 'Buy Seat',
  planDescription: 'Plan Description',
  saveUptoText: 'Save up to 38%'
};

export const infoModalText = {
  subscribe: 'Subscribe',
  trialNote: 'You will be charged at the end of the 7-day trial.',
  downgradeNote:
    'Your plan will stay active until the end of the billing period.',
  upgradeNote:
    'Your card will be charged immediately with the pro-rated amount.',
  minChar: 'Minimum 20 characters'
};

export const invoicesText = {
  invoices: 'Invoices',
  type: 'Type',
  amount: 'Amount',
  status: 'Status',
  paymentMethod: 'Payment Method',
  noInvoicesFound: 'No invoices found',
  toSeeOlderInvoices: 'To see older invoices, reach out to',
  noInvoicePdf: 'No invoice found'
};

export const individualScanText = {
  freePlanDescription:
    'Page scans on our free plan allow you to check any Squarespace web page for common SEO pitfalls.',
  freePlanFullDescription:
    'This page allows you to complete an SEO scan on pages on any Squarespace website. Simply click “Scan Webpage”, enter the URL and press “Run Scan” - once your scan is complete, press “View Scan” to open that web page and view the results via the SEOSpace plugin.',
  otherPlanFullDescription:
    'This page allows you to scan individual pages of websites that aren’t in your site audit slots. From here, you can audit potential clients, competitors or a friend’s site.',
  webPageUrl: 'Webpage URL',
  seoScore: 'SEO Score',
  keyword: 'Keyword',
  keywordVolume: 'Keyword Volume',
  installPluginTitle: 'Install SEOSpace’s Plugin',
  installPluginDesc:
    'Before getting started, install the SEOSpace plugin from the Chrome Store using the Install Plugin button. Please refresh this page once the plugin is installed.',
  installPlugin: 'Install Plugin',
  tutTitle: 'Learn More About External Scans',
  freeTutTitle: 'Complete Free Plan Tutorial',
  watchTutorial: 'Watch Tutorial (02:27)',
  scannedUrls: 'Scanned URLs',
  videoLink: 'https://www.youtube.com/watch?v=RR7IdoZifbE'
};

export const memberText = {
  invitedBy: 'You have been invited by',
  createAccount: 'Create Account'
};

export const status404Text = {
  firstTitle: "The page you were looking for doesn't exist.",
  description:
    "It's on us, we moved the content to a different page. The search below should help!",
  gotoScan: 'Go to Scan'
};

export const status500Text = {
  title: 'There was an error, please try again later',
  description:
    'The server encountered an internal error and was not able to complete your request',
  refreshView: 'Refresh view',
  goBack: 'Go back',
  seoSpace: 'SEOSpace',
  overview: 'Overview'
};

export const maintenanceText = {
  underMaintenance: 'We are under maintenance.',
  description:
    'We are updating our application. We will be back soon with new features.'
};

export const planText = {
  pricing: 'Pricing',
  description: 'Simple pricing plans that you can start or cancel at any time.',
  monthly: 'Monthly',
  annually: 'Annually',
  planTimeline: '/mo',
  subscribed: 'Subscribed'
};

export const seoIssuesText = {
  stillInprogress: 'Site audit is still in progress....',
  noDataFound: 'No data found',
  stillInprogressNoDots: 'Still in progress',
  dashboard: 'Here you can find the top SEO tasks on',
  betaDescription:
    'BETA - our broken link checker is ~95% accurate and we are working on improving it',
  blogDescription: `BETA: Suggested blog posts is a new feature - if you face any problems or have any questions, please reach out to support using the chat icon in the bottom right hand corner. Please note that you can generate blog post suggestions up to 3 times/day. If your suggested blog posts aren't accurate, please make your business details more descriptive in "Edit Business Details"`,
  tooltipText:
    'SEO tasks are a list of prioritized SEO tasks that are most likely to rank your website higher on search engines. Each task contains step-by-step instructions on how to best complete it on Squarespace.'
};

export const seoScore = 'SEO Score';
export const lastUpdate = 'Last Update: ';
export const update = 'Update';

export const pdfComponentText = {
  last30Days: 'Last 30 days',
  inTop10: 'On page 1 of Google',
  imgSizeWarning: 'Please select a PNG image that is 2MB or smaller.',
  imgTypeWarning: 'Please select a PNG image.'
};

export const monitoringModalText = {
  everyWeek: 'Every Week',
  everyMonth: 'Every Month',
  issueInfo: 'There is some issue. Please try again.',
  scheduleMonitoring: 'Schedule Monitoring',
  description: 'To delete your current monitoring settings,',
  clickHere: 'Click here',
  notScanned: 'Not Scanned',
  monitoringTitle: 'Setup SEO & Orbit AI Monitoring',
  monitoringTitleEnterprise: 'Setup SEO Monitoring',
  monitoringTutorial:
    'https://www.youtube.com/watch?v=J6MrZhgK3FI&list=PLlaoclvOMRPyFA6ylbOSMH3-0Ah3txns4',
  watchTutorial: 'Watch Tutorial (02:00)',
  frequency: 'Frequency',
  monitoringText: 'Monitoring of the site',
  emailLabel:
    'Want the monitoring emails to also be sent to a team member or client? Add their email(s) below:'
};

export const rowText = {
  previousScans: 'Previous scans',
  refreshText:
    'This scan is taking some time - please wait and refresh in 1-2 minutes.',
  viewScanProgressingText: `This scan is still in progress - please wait for a score to be shown before clicking "View Scan".`,
  deleteScanProgressingText: `This scan is still in progress - please wait for a score to be shown before clicking "Delete Scan".`
};

export const secondCardText = {
  infoIconText:
    'The below shows the number of organic clicks you received from Google in the past 30 days. This is broken down into the country those clicks came from.'
};

export const thirdCardText = {
  infoIconText:
    'The number of clicks you received from organic traffic in the past 30 days.',
  keywordInfoIconText:
    'The number of keywords you rank for in the top 10 (i.e. page 1) on Google’s search engine results.'
};

export const websiteAuditAfterLinearBarText = {
  title: 'Website Monitoring:',
  nextUpdate: 'Next update:',
  actions: 'Actions',
  deleteAudit: 'Delete Site'
};

export const siteAuditModalText = {
  watchThisTutorial: 'Watch this tutorial',
  morePagesToSkip: ' to learn more about which pages to skip.',
  limitText:
    'BETA: Scanning websites with >100 pages is currently in beta; there may be some inaccuracies that we are working on. If your site-wide scan freezes, please stop the audit and try again.',
  serverHighTraffic:
    'Our server is currently facing a higher than usual demand. To prevent overloading the server, please retry adding your site audit in ~5 minutes time. Apologies for any inconvenience caused.'
};

export const skippedUrlsListText = {
  noSkippedFound: 'No skipped URLs found'
};

export const skipUpdateFieldsText = {
  skipProcess: ' Yes, skip this process',
  noGoBack: 'No, go back'
};

export const websiteAuditDashboardText = {
  pdfFooterText: 'The report data is taken from SEOSpace.',
  pdfGeneratingText: 'Please wait; your PDF report is being generated.',
  seoReport: 'SEO Report',
  siteAuditOverview: 'Site Audit Overview',
  pdfDate: 'Date:',
  pdfCompareDate: 'Compare date:',
  gscErrorText: 'GSC error text'
};

export const auditSitesDropdownText = {
  auditNewSite: 'Audit a New Website',
  addSiteToAnalyze: 'Add site to analyze',
  addWebsites: 'Add Website',
  viewAllWebsites: 'View All Websites '
};

export const reAuditCheck = {
  firstDescription: 'Are you sure you want to re-audit your whole website?',
  subDescription:
    'If you have only optimized a few pages on your site, it will be quicker to re-scan the optimized pages (than your whole site), which will automatically update your site-wide health score.',
  secondSubDescription:
    'You have used up all of your site-wide audits for this site today. Don’t worry - you can simply re-scan individual web pages that you’ve optimized, which will automatically update your site-wide score. Alternatively, you can come back in 24 hours.',
  reAudit: 'Re-audit',
  reScanIndividual: 'Re-scan individual pages',
  cancel: 'Cancel'
};
export const addScanModalText = {
  viewKeyword: 'View Recommended keywords',
  closeKeyword: 'close recommended keywords',
  generatingKeyword: 'Generating keywords',
  noKeywordDescription:
    'Note: If this is a new web page, suggested keywords might not show yet. Please come back later once your page is ranking for keywords.'
};

export const viewScanDialogText = {
  descTitle: 'Select whether you’d like to view your scan results from the: ',
  description:
    '<b>Squarespace editor</b> (this allows you to improve your SEO from one tab - you must have editor access or more on this Squarespace site - please wait 5 seconds for the plugin to load)',
  previousDescription:
    '<b>Squarespace editor</b> (viewing previous/historical scan results on the Squarespace editor is not available - please select "Live URL" to see previous scan results.)',
  betaText:
    '<b>Live web page/URL</b> (view results from one tab and make improvements on the Squarespace editor in another)'
};

export const blogModal = {
  blogModalDescription:
    'Enter the details of your business and competitors below - this will allow SEOSpace to provide more accurate blog recommendations - you can generate blog titles up to 3 times/day - ',
  businessDescriptionPlaceHolder:
    'Enter a 100+ character description of your business, detailing what product/service you offer, the goals and pain points of your target customers and anything you want SEOSpace to know to improve our suggestions.',
  watchTutorialLink: 'https://www.youtube.com/watch?v=qMZTnHEzpaY',
  watchThisTutorial: 'watch this tutorial'
};

export const siteAuditLinks = {
  watchTutorialLink: 'https://www.youtube.com/watch?v=gSakWx1-isI'
};

export const leadGeneration = {
  previewForm: 'Preview Form',
  previewClose: 'Close',
  editHeading: 'Edit Options',
  newForm: 'New Form',
  editForm: 'Edit Form',
  textAlignment: 'Text Alignment',
  leadGenerationHeading: 'Lead Generation',
  leadGenerationDescription:
    'In “Lead Generation”, you can view all the leads generated through your “Free SEO Audit” form. To capture leads, generate a form, embed it into your Squarespace website and advertise your new lead magnet!',
  leadGenerationWatchTutorial: 'Watch this tutorial to learn more.',
  fontColour: 'Chosse Font Colour',
  formBuilder: 'Form Builder',
  formBuilderDescription:
    "Users have the ability to add fields through drag-and-drop functionality. It's important to note that Email and Hyperlink serve as default fields and cannot be removed. Furthermore, customization options extend to modifying the appearance and text of these fields, with real-time previews available for seamless evaluation.",
  textChangeNote: 'Enter the text field label, leave blank if not needed.',
  scriptHeader: 'Embed Code Script',
  scriptDescription:
    'Copy the below code and add it to a code block on your Squarespace web page.',
  leadFormDescription:
    'Make finishing touches to your form below before clicking “Generate Code” and embedding it into your Squarespace website.',
  formSuccessDescription:
    'Please add the success message if want to show a custom message after on form submission',
  formButtonDesription:
    'You can change the default submit button text and color',
  formButtonLabel: 'Select button colour:',
  formColorLabel: 'Select form colour:',
  closeButton: 'Close',
  deleteLeadDescription: 'Are you sure you want to delete this lead?'
};

export const planNames = {
  starter: 'starter',
  starterPlus: 'starterplus',
  diy: 'diy',
  free: 'free',
  designer: 'designer',
  agency: 'agency',
  expertPlus: 'expertplus',
  proPlus: 'proplus',
  localseo: 'localseo',
  enterprise: 'enterprise'
};

export const confirmSlotsBuyTexts = {
  activatedSlots: 'Currently Activated Seats: ',
  selectNumberOfSlot: 'Select number of seats you wish to buy : '
};

export const scriptUrl = scriptURL;

export const DateModalTexts = {
  description:
    'Change the date format that appears across SEOSpace using the below selectors.'
};

export const useInactivityTrackingTime = 900000; // 15 Minutes

export const keywordResearchLinks = {
  thirdKRPoint: 'https://www.youtube.com/watch?v=-TtLLxyVCm8'
};

export const keywordResearchTexts = {
  keywordResearch: 'Keyword Research',
  limit: 3,
  keywordResearchDescription: 'what is your goal for today?',
  keywordResearchListItems: [
    {
      text: 'I want to find out what people search for about my niche or industry',
      url: paths?.keywordOverview,
      icons: 'key.svg'
    },
    {
      text: 'I want to see what my competitors show up for on Google',
      url: paths?.competitorAnalysis,
      icons: 'chart.svg'
    },
    {
      text: 'I want to track my Google rankings for specific keywords over time',
      url: paths?.keywordTracking,
      icons: 'track-green.svg'
    },
    {
      text: 'I want blog ideas based on what my competitors rank for',
      url: paths?.blogPostIdeas,
      icons: 'rocket-green.svg'
    },
    {
      text: `I want to keep track of the best keywords I find, all in one place`,
      url: paths?.keywordsLists,
      icons: 'box.svg'
    },
    {
      text: `I don't know where to start or how to find keywords`,
      url: keywordResearchLinks?.thirdKRPoint,
      icons: 'question.svg'
    }
  ]
};

export const otherToolTexts = {
  keywordResearch: 'Local SEO Tools',
  limit: 3,
  keywordResearchDescription: 'what is your goal for today?',
  keywordResearchListItems: [
    //{
    //  text: 'See the backlinks pointing to your site or your competitors’ — and spot new opportunities.',
    //  url: paths?.backlinkPage,
    //  icons: 'dataset.svg'
    //},
    {
      text: 'Get step-by-step actions to rank higher and attract local customers',
      url: paths?.localChecker,
      icons: 'track-green.svg'
    },
    {
      text: 'Edit and update your Google Business Profile in seconds',
      url: paths?.localTasks,
      icons: 'clipboard-tick.svg'
    },
    {
      text: 'Reply to reviews, build trust, and grow your reputation',
      url: paths?.googleReviews,
      icons: 'star.svg'
    },
    {
      text: 'Share offers and updates to drive clicks and foot traffic',
      url: paths?.businessPosts,
      icons: 'edit-2.svg'
    },
    {
      text: 'Track your local rankings and see how competitors are performing',
      url: paths?.mapRankTracker,
      icons: 'map.svg'
    }
    //{
    //  text: 'Attract more customers with automatic listings on Yelp, Apple Maps, Bing, and more',
    //  url: paths?.listingManager,
    //  icons: 'chart.svg'
    //}
  ]
};

export const keywordOverviewTexts = {
  keywordOverview: 'Keyword Explorer',
  analyzeData: 'Enter keyword to explore related terms',
  searchCountry: 'Search location',
  search: 'Search',
  findProfitable: 'Find profitable SEO keywords that are easy to rank for.',
  getTheBest:
    'Get the best results possible with our user-friendly keyword research tool.',
  youWillGet: 'You will get: ',
  keywordSearchVolume: 'Keyword search Volume',
  selectedGeography: '- by selected geography and global.',
  keywordDifficulty: 'Keyword difficulty',
  betterRanking: '- find low-difficulty keywords for better ranking.',
  relatedKeywordsList: 'Related keywords list',
  boostYourWebsite: `- boost your website's visibility in search results.`,
  competitorTutorial: 'Competitor Analysis Tutorials',
  competitorTutorialLink: 'https://www.youtube.com/watch?v=-TtLLxyVCm8&t=288s',
  keywordResearchTutorials: 'Keyword Explorer Tutorial',
  keywordResearchTutorialsLink: 'https://www.youtube.com/watch?v=-TtLLxyVCm8',
  examples: 'Examples: ',
  exampleOptions: 'Web design, wedding photographer, best food in NYC',
  viewAll: 'View All',
  blogPostTutorial: 'Blog Post Suggestions Tutorial',
  blogPostTutorialLink:
    'https://www.youtube.com/watch?v=i1xL2HpheB0&list=PLlaoclvOMRPyFA6ylbOSMH3-0Ah3txns4',
  keywordListTutorialsLink: 'https://www.youtube.com/watch?v=Xp0zf1rdoQk',
  backLinkTutorialsLink: 'https://www.youtube.com/watch?v=JGVMYrwN10c',
  exactTooltip:
    'In this mode, we show keyword ideas that contain your target keyword or phrase in the order you’ve written it.',
  phraseTooltip:
    'In this mode, we show keyword ideas that contain all the words from your query in any order.'
};

export const KeywordOverviewResultCardsTexts = {
  keywordOverview: 'Keyword Explorer: ',
  design: 'design',
  addToKeywordList: 'Add to keyword list',
  searchVolume: 'Search Volume',
  numOne: '22,200',
  globalVolume: 'Global Volume',
  cpc: 'CPC',
  numTwo: '1,2M',
  difficulty: 'Keyword Difficulty',
  keywordDifficulty: 'Keyword Difficulty',
  numThree: '26',
  keywordDescOne: 'This keyword has',
  keywordDescSpan: 'high level',
  keywordDescTwo: 'of competitiveness.',
  intent: 'Search Intent',
  commercial: 'Commercial',
  thisWords: 'Commercial intent keywords suggest  ',
  high: 'potential purchase',
  conversion: 'interest.',
  status: 'Status',
  notCovered: 'Not Covered',
  keywordDescThree:
    'The following page on your selected site ranks for this keyword: ',
  keywordDescUrl: '/squarespace-seo-course-and-training',
  allLists: 'All Lists',
  noLists:
    'You haven’t created a keyword list yet. Create a list to begin saving your keywords.',
  createNewList: 'Create New List',
  cancel: 'Cancel',
  create: 'Create List',
  reconnect: 'Reconnect GSC',
  keywordDifficultyLow:
    'This keyword has a low level of difficulty and is easier to rank for.',
  keywordDifficultyMedium:
    'This keyword has a medium level of difficulty and requires more effort to rank for.',
  keywordDifficultyHigh:
    'This keyword has a high level of difficulty and is tough to rank for.',
  keywordDifficultyVeryHigh:
    'This keyword has a very high level of difficulty and is very challenging to rank for.',
  comIntentDescFirst: 'Commercial intent keywords suggest  ',
  comIntentDescSpan: ' potential purchase',
  comIntentDescSec: ' interest.',
  infoIntentDescFirst: 'Informational intent keywords indicate a search for ',
  infoIntentDescSpan: 'knowledge or information.',
  navIntentDesc: 'Navigational intent keywords indicate a desire to find a ',
  navIntentDescSpan: 'specific website or page.',
  traIntentDesc: 'Transactional intent suggests an intent to complete a ',
  traIntentDescSpan: 'purchase or transaction.',
  multiIntent: 'This keyword indicates',
  position: 'Your Position',
  positionFirstDesc:
    'The following web page on your selected website ranks position',
  positionSecondDesc: 'for this keyword on Google:',
  positionNotRankDesc:
    'Your selected website does not rank for this keyword in your selected geography.',
  positionError:
    'Google Search Console has a limit on how many pages SEOSpace can check per day. Your account has hit that limit - please try again in 24 hours once the limit is removed.',
  update: 'Update',
  lastUpdate: 'Last Update: ',
  updateToolTipText:
    'Update the data by running a new search. This will deduct 1 search credit.',
  chipToolTipText:
    'This keyword is already being tracked for the selected location. It won’t be added again, and no additional credits will be used.',
  createList: 'Create your list to add keyword.',
  deductionMessage: ' Viewing backlinks will use another search.',
  creditOver: "Looks like you've used up all your searches. Buy more searches",
  viewBackLinks: 'View Backlinks',
  proceed: 'Proceed',
  deductionMessageTooltip:
    ' Viewing this site’s backlinks will use 1 search credit.',
  allFolders: 'All Folders',
  createFolder: 'Create your folder to add list.',
  createFolderBtn: 'Create Folder'
};
export const KeywordOverviewTableTexts = {
  relatedKeywords: 'Related Keywords',
  searchVolume: 'Search Volume',
  keywordDifficulty: 'Keyword Difficulty',
  intent: 'Intent',
  status: 'Status',
  wordCount: 'Word Count',
  exportCsv: 'Export to CSV',
  relatedKeywordsList: 'View all related keywords',
  noRelatedKeywords: 'No related keywords.',
  noRelatedKeywordsDesc: `We've found there are no related keywords to this search term. Please try a broader keyword to get suggestions.`,
  numberOfKeyword: 'Number of keywords',
  exportFirst: 'Export first 1000 keywords',
  custom: 'Custom',
  format: 'Format',
  csvForExcel: 'CSV (UTF-16, for Excel)',
  csvForOpenOffice: 'CSV (UTF-8, for OpenOffice, Libre Offcie, etc.)',
  cancel: 'Cancel',
  export: 'Export',
  connectGsc: 'Connect GSC',
  noKeywords: 'No Keywords Found',
  noKeywordsDesc:
    'We’ve found this website doesn’t rank for any keywords. Please try a different website or contact support if there has been a mistake.',
  exportFirstBackLinks: 'Export first 1000 backlinks',
  numberOfBackLinks: 'Number of backlinks'
};

export const CompetitorAnalyzeTexts = {
  competitorAnalyze: 'Competitor Analysis',
  competitorData: 'Enter competitor to analyze',
  getStarted: 'Get Started: ',
  getStartedDesc:
    'Enter your competitor’s domain, subdomain or URL and click ‘Search’ to analyze.',
  getStartedDescError:
    'This site doesn’t rank for any keywords. This either means it’s an incorrect URL, or the website is so new/small that no data is found. Please try a new search with a different site.',
  getStartedDescBackLinksError:
    'We have found this URL has backlinks but no organic traffic - this might mean the website is completely new or not currently published.',
  examples: 'Examples: ',
  exampleOptions: 'amazon.com, blog.example.com, en.wikipedia.org',
  previousSearches: 'Previous Searches'
};

export const CompetitorInfoTexts = {
  getComprehensive: 'Get comprehensive analysis of your competitor.',
  gainInsight: `Gain insights into a domain's online presence`,
  identify: 'Identify key markets it leads in',
  unCover: 'Uncover top-performing keywords driving traffic'
};

export const CompetitorAnalysisResultCardsTexts = {
  competitorAnalyze: 'Competitor Analysis: ',
  example: 'example.com',
  estimatedOrganicTraffic: 'Organic Traffic',
  numOne: '5.6M',
  totalKeywords: 'Total Keywords',
  numTwo: '180',
  domainAuthority: 'Domain Authority',
  numThree: '65',
  backlinks: 'Backlinks',
  numFour: '120',
  topOrganicKeywords: 'Top Organic Keywords',
  snackBarText:
    'Keep in mind that keyword positions displayed are approximate estimates and may vary.',
  snackBarWatch: 'Watch Tutorial about Competitor Analysis',
  viewBacklinks: 'View Backlinks'
};

export const CompetitorAnalysisTableTexts = {
  position: 'Position',
  volume: 'Volume',
  kd: 'KD %',
  traffic: 'Traffic',
  organicKeywords: 'View all top organic keywords'
};

export const BlogPostIdeasDashboardTexts = {
  blogPostIdeas: 'Blog Post Ideas',
  snackBarTitle: 'Blog post suggestions generated!',
  snackBarDesc: `These blog post ideas are generated through a "content gap analysis". SEOSpace finds the keywords your competitors rank for, which `,
  snackBarDescTwo: ` doesn't, and then turns these into blog post suggestions to close the gap between your site and the competition. Try adding different competitors and improving your business/website description in step 1 to generate more ideas!`
};

export const BlogPostStepperTexts = {
  stepOneDesc:
    'Enter the details of your business below - this will allow SEOSpace to provide more accurate blog recommendations.',
  urlInputLabel: 'Enter your URL',
  urlInputFieldLabel: 'Enter domain, subdomain or URL',
  urlInputError: 'URL is required',
  businessNameLabel: 'Enter your business name',
  businessNameFieldLabel: 'Enter the name of your business',
  businessNameError: 'Business name is required',
  businessDescLabel: 'Please describe what ',
  businessDescLabelTwo:
    ' does - what is its offer and the problem it solves its customers/visitors?',
  businessDescFieldLabel: 'Enter a description...',
  businessDescError: 'Business Description is required',
  businessDescMessage: 'Please enter a minimum of 100 characters.',
  stepTwoDesc: `Add up to 3 of your competitors below. If you don’t have “direct competitors,” add websites you see ranking well on Google in your niche. Note: Each competitor you add will use 1 search credit.`,
  infoText:
    'If there are no direct competitors for your business or website, consider adding a site that offers similar information, products, or services.',
  addCompetitor: 'Add competitor',
  createBrief: 'Create Brief',
  unlockBlogPost: ' Unlock Blog Post Ideas',
  unlockKeywordExplorer: ' Unlock Keyword Explorer',
  unlockCompetitoAnalysis: ' Unlock Competitor Analysis',
  unlockDesc: `Find blog post ideas based on the keywords that competitors rank for, that you don't - i.e. see the gap between you and your competitors.`,
  upgradePlan: ' Upgrade Plan',
  slotDesc: `Looks like you've used up all your searches. Buy more searches to generate blog post ideas.`,
  searchCredits: 'Buy Search Credits',
  checkBoxError: 'Please select at least one competitor URL to proceed.',
  maxCompetitorLimitError:
    'You can only keep a maximum of 3 competitors. Please remove additional competitors to proceed.',
  cancel: 'Cancel',
  generate: 'Generate',
  blogLoader: 'Generating Blog Post Ideas...',
  briefLoader: 'Creating Blog Post Brief (BETA)...'
};

export const drawerDataTexts = {
  blogPostTitleIdea: 'Blog Post Title Idea',
  trends: '10 Digital Marketing Trends for 2024',
  keywords: 'Keywords',
  numOne: '10',
  difficulty: 'Avg. Difficulty',
  numTwo: '12.8',
  competitors: 'Competitors',
  numThree: '111',
  startOver: 'Start Over',
  back: 'Back'
};

export const KeywordsListsDashboardTexts = {
  keywordsLists: 'Keywords Lists',
  delete: 'Delete List',
  add: 'Rename List',
  createNewList: 'Create New List',
  totalVolume: 'Total Volume',
  avgKd: 'Avg. KD %',
  userTutorial: 'New to Keyword Lists? Here’s how they work',
  createNewFolder: 'Create New Folder',
  createNew: 'Create New',
  deleteFolder: 'Delete Folder',
  renameFolder: 'Rename Folder'
};

export const ListDataTableTexts = {
  listName: 'Name of the list 1',
  selected: 'Selected: ',
  deselectAll: 'Deselect all',
  delete: 'Delete',
  listPage: 'List Page',
  addToKeywordsList: 'Add to Keyword List',
  copy: 'Copy',
  copied: 'Copied!',
  addToFolder: 'Add to Folder'
};

export const allRelatedKeywordTexts = {
  allRelatedKeywords: 'All Related Keywords: ',
  allRelatedKeyword: 'All Related Keywords'
};

export const topOrganicKeywordTexts = {
  topOrganicKeywords: 'Top Organic Keywords'
};

export const keywordOverviewTableHeaders = [
  'Keywords',
  'Volume',
  'CPC',
  'KD %',
  // 'Golden KR',
  //'Position',
  'Search Intent'
];

export const keywordOverviewSearchOptions = [
  '1-10',
  '11-100',
  '101-1,000',
  '1,001-10,000',
  '10,001-100,000',
  '100,001+'
];

export const keywordOverviewKDOptions = [
  '1-29',
  '30-50',
  '51-69',
  '70-80',
  '81-100'
];

export const keywordOverviewStatusOptions = ['Covered', 'Not Covered'];

export const keywordOverViewPositionOptions = [
  'Not ranking',
  '1-10',
  '20-50',
  '50-100'
];

export const keywordOverviewIntentOptions = [
  'Informational',
  'Navigational',
  'Commercial',
  'Transactional'
];

export const customPopoverTexts = {
  keywordGoldenRatio: 'Keyword Golden Ratio, %',
  wordCount: 'Word Count',
  apply: 'Apply',
  clearFilters: 'Clear filters',
  customRange: 'Custom Range',
  errorText: 'To value must be greater then from'
};

export const keywordResearchToolTipTexts = {
  searchVolume:
    ' - this is the total number of people that search for this keyword on Google, per month, in your selected geography.',
  cpc: '(cost-per-click) - this is an estimate of how much it would cost to run Google Ads for this keyword per click - a high cost per click indicates a lucrative keyword that advertisers pay a lot for (and likely make a lot of money from!).',
  keywordDifficulty:
    ' - this is an estimate of how competitive it is to rank on page 1 of Google for this keyword out of 100. 0 is very easy, 100 is extremely hard.',
  intent: `- This estimates why someone is searching for this keyword. There are 4 types of search intent: Commercial, Transactional, Navigational and Informational. `,
  watchThisVideo: 'Watch this video',
  toLearnMore: ' to learn more.',
  intentLink: 'https://youtu.be/cIi4TGcnKDw',
  status:
    '- this tells you whether your selected website ranks on pages 1-2 on Google for this keyword. This is based on Google Search Console data for your selected geography in the past 30 days. If the status is “covered”, your selected site ranks on pages 1 or 2 for this keyword.',
  getStarted: 'Get Started: ',
  getStartedLink: 'https://www.youtube.com/watch?v=-TtLLxyVCm8',
  watchThisTutorial: 'Watch this tutorial',
  getStartedDesc: `Enter a keyword to see related keywords and ideas. If you're unsure, type what you think your target customer would search when looking for your product or service. `,
  getStartedDescErrorOne: 'No related keywords were found for ',
  getStartedDescErrorTwo:
    ' because it’s either too niche or no related keywords are being searched for that we can find. Please try again with another search to get ideas.',
  globalVolume:
    '- this is the total number of people who search for this keyword on Google per month, globally.',
  positionOne: ' - this tells you whether or not ',
  positionTwo:
    ' ranks for this keyword - if it does, SEOSpace will tell you the average position it ranked in the past 30 days based on Google Search Console data.',
  positionThree:
    ' - this tells you whether or not the selected website ranks for this keyword - if it does, SEOSpace will tell you the average position it ranked in the past 30 days based on Google Search Console data.'
};

export const keywordResearchToolTipRowTexts = [
  '',
  'Search Volume - this is the total number of people that search for this keyword on Google, per month, in your selected geography.',
  `CPC (cost-per-click) - this is an estimate of how much it would cost to run Google Ads for this keyword per click - a high cost per click indicates a lucrative keyword that advertisers pay a lot for (and likely make a lot of money from!).`,
  'Keyword Difficulty - this is an estimate of how competitive it is to rank on page 1 of Google for this keyword out of 100. 0 is very easy, 100 is extremely hard.',
  // 'Golden Keyword Ratio - this is an indicator of how competitive a keyword is - it’s a ratio between how many pages on Google are optimized for this keyword and how many people search for it per month. If the ratio is <2.5%, it’s a “golden keyword”. Watch this to learn more.',
  //`Your Position - this tells you whether or not SELECTED WEBSITE ranks for this keyword - if it does, SEOSpace will tell you the average position it ranked in the past 30 days based on Google Search Console data.`,
  `Search Intent - This estimates why someone is searching for this keyword. There are 4 types of search intent: Commercial, Transactional, Navigational and Informational. `
];

export const keywordResearchKdSubOptions = [
  'Easy',
  'Medium',
  'Difficult',
  'Hard',
  'Very Hard'
];

export const competitorAnalysisToolTipTexts = {
  organicTraffic: `- this is the estimated monthly traffic this website receives from Google in the selected geography.`,
  totalKeywords: `- this is the estimated number of keywords this website currently ranks for on Google.`,
  domainAuthority: `- DA is a score given to a website that deems how much of an “authority” it is on the internet - the more high quality backlinks, the higher the DA and more likely the site is to rank for competitive keywords.`,
  backLinks: `- this shows the number of backlinks this site has. Backlinks are links from other websites to this one - the more high-quality backlinks a website has, the higher its domain authority and chances of ranking for competitive keywords. Quality and quantity is important when it comes to backlinks.`,
  domainAuthorityHead: 'Domain Authority (DA)'
};

export const exportCsvModalTexts = {
  generating: 'Please wait, the system is generating a file... ',
  success: ' File Successfully Generated!',
  download: 'Download'
};

export const competitorAnalysisTableHeadToolTip = [
  '',
  'Webpage - This column shows the page on your competitors website, which ranks for the keyword shown.',
  'Position - an estimate of what position your competitor ranks for each keyword on Google, for your selected geography.',
  'Traffic - an estimate of how much traffic your competitor gets each month, for each keyword.',
  'Search Volume - this is the total number of people that search for this keyword on Google, per month, in your selected geography.',
  'Keyword Difficulty - this is an estimate of how competitive it is to rank on page 1 of Google for this keyword out of 100. 0 is very easy, 100 is extremely hard.',
  `Search Intent - This estimates why someone is searching for this keyword. There are 4 types of search intent: Commercial, Transactional, Navigational and Informational. `,
  `Your Position - this tells you whether or not SELECTED WEBSITE ranks for this keyword - if it does, SEOSpace will tell you the average position it ranked in the past 30 days based on Google Search Console data.`
  // 'Status - is determined by whether your webpage cover this specific keyword or not.'
];

export const competitorAnalysisPositionOption = [
  '1-20',
  '21-50',
  '51-100',
  '101-200'
];
export const competitorAnalysisTrafficOption = [
  '1-500',
  '501-1000',
  '1001-1500'
];
export const competitorAnalysisBackLinksOption = [
  '1-500',
  '501-1000',
  '1001-1500'
];

export const competitorAnalysisKDOption = [
  '1-30',
  '31-50',
  '51-60',
  '61-80',
  '81-100'
];

export const SQSPDescription =
  'To successfully create your account with Squarespace, we need your first name and email.';

export const UpgradeSearchCreditModalTexts = {
  title: `You’re out of search credits...`,
  description: `Looks like you've used up all your search credits. Please upgrade your plan.`,
  // buyCredits: 'Buy Searches',
  buyCredits: 'Contact Support',
  upgradePlan: 'Upgrade Plan',
  descOne:
    'You have exhausted your monthly credits for this month. Please wait till',
  descTwo: 'to have your credits refilled',
  descThree: 'your next billing cycle to have your credits refilled.'
};

export const keywordOverviewBlurTexts = {
  header: 'Unlock All Related Keywords',
  comHeader: `See Competitor's Keywords`,
  headerTopOrganic: 'Unlock Top Organic Keywords',
  description: 'Upgrade your plan to view all related keywords.',
  proDescription:
    'Buy more searches or Upgrade your plan to continue viewing Related Keywords.',
  agencyDescription: 'Buy more searches to continue viewing Related Keywords.',
  comDesc: `Upgrade your plan to see a full list of keywords your competitors rank for.`,
  comDescPro:
    'Buy more searches or Upgrade your plan to see a full list of keywords your competitors rank for.',
  comDescAgency:
    'Upgrade your plan to see a full list of keywords your competitors rank for.'
};

export const searchesProgressBarTexts = {
  toolTipHeader: '# of searches',
  toolTipDescription:
    '- is the max number of keyword searches you can perform each month according to your subscription plan, which resets at the start of each billing month.',
  snackBarDesc: ' searches have been successfully added.',
  toolTipKeywordHeader: '# of keywords',
  addKeywordToolTipDescription:
    'The number of keywords you are tracking on your SEOSpace account. You can track a total of 100 keywords at any given time.'
};

export const viewAllKeywordModalTexts = {
  heading: 'Go to Keyword Explorer?',
  descOne: 'Viewing another keyword counts as ',
  searchNum: `1 ‘search’`,
  doNotShow: `Don't show this again`,
  continue: 'Continue',
  diyDesc: `Clicking on a keyword will take you to the related keywords for that keyword. Do you want to continue?`,
  descTwo:
    ', as SEOSpace will also search for all related keywords to it. To continue, please click below.'
};

export const UpgradePlanLiteModalTexts = {
  header: 'Upgrade for Unrestricted Keyword Research Access',
  desc: `You are currently using Keyword Research Lite. Upgrade your plan to access unrestricted keyword research and the ability to see your competitors' keywords.`,
  upgradePlan: 'Upgrade Plan',
  newHeader:
    'Get Full Access to Blog Post Ideas: Upgrade or Buy Search Credits',
  newDesc: `Find blog post ideas based on the keywords that competitors rank for, that you don’t - i.e. see the gap between you and your competitors.`,
  buyCredits: 'Buy Search Credits',
  kwHeader: 'Upgrade to Access More Search Credits',
  agencyHeader: `You've Reached Your Search Credit Limit`,
  agencyDesc: `You've reached your monthly usage limits - either buy more search credits, or wait until your plan renews for your limits to refresh.`,
  kwDesc:
    'You have run out of search credits - either wait until your plan renews to receive more, or upgrade to receive to increase your monthly usage limits. ',
  buySearchCredit: 'Buy search credits',
  contactUs: 'Contact Us'
};

export const KeywordOverviewResearchModalTexts = {
  heading: 'Go to Keyword Overview?',
  thisTakeUp: 'This take up',
  searchCredit: '1 search credit',
  youWillHave: 'and you will have',
  searchesLeft: 'searches left.',
  likeToContinue: 'Would you like to continue?'
};

export const downloadPluginModalTexts = {
  install: 'Install SEOSpace’s Plugin',
  description:
    'You have not installed our Chrome plugin yet. Please click the button below to install SEOSpace and begin viewing your scans.'
};

export const siteAuditMenuHeadings = {
  scannedPage: 'Scanned Pages',
  seoTasks: 'SEO/AIO Tasks',
  externalScan: 'External Scans',
  pageScans: 'Page Scans',
  siteAudit: 'Site Audit',
  aiVisibility: 'AI Visibility'
};

export const otherToolMenuHeadings = {
  backlinkPage: 'Backlink Analysis',
  mapRankTracker: 'Local Ranking Tracker',
  localChecker: 'Dashboard',
  localSEOTasks: 'Local SEO Tasks',
  googleReviews: 'Google Reviews',
  businessPosts: 'Business Posts',
  listingManager: 'Listing Manager',
  citationBuilder: 'Citation Builder',
  localSeoAi: 'Local SEO AI'
};

export const orbitAiMenuHeadings = {
  keywordAssist: 'Keyword Assist',
  contentStrategy: 'Content Strategy',
  blogPostAgent: 'Blog Post Agent',
  localSeoAi: 'Local SEO AI',
  reviewAutomation: 'Review Automation',
  contentPlan: 'Content Plan'
};
export const exportCsvIcon = '/static/images/icons/upload_icon.svg';
export const snackBarErrorText =
  'We are receiving an unusually high amount of scan requests - please try again in 1 minute.';

export const squareSpaceUtm = 'squarespace_utm';
export const squareSpaceUtmAPIExt = '?utm=sqsp';
export const squareSpaceUtmOnBoardingAPIExt = '?utm=on_boarding';
export const squareSpaceUtmLocalSeo = '?utm=localseo';
export const squareSpaceNonUtmLocalSeo = '?via=localseo';

export const squareSpaceConnectTexts = {
  accessDenied: 'Access Denied: Please allow access to proceed.',
  clickToAllow: ' Click here to allow.',
  utmOnBoardingValue: 'on_boarding',
  utmValue: 'sqsp',
  localseo: 'localseo'
};

export const isLoginOrSignup = 'isFromLoginOrSignUp';

export const newCommonChromeExtensionModalTexts = {
  installPlugin: 'Install SEOSpace Plugin',
  desc: 'Before getting started, install the SEOSpace plugin from the Chrome Store using the Install Plugin button. Please refresh this page once the plugin is installed.'
};

export const subscriptionPaymentFailedTexts = {
  title: 'Payment Failed',
  desc: 'We were unable to process your recent payment. Please update your payment method to continue using SEOSpace.',
  updatePayment: 'Update Payment Method'
};

export const scanInfoText = {
  desc: `Click "Scan Webpage," enter a Squarespace URL in the pop-up, and start the scan. Once it's done, click “View Scan” to see the results.`,
  descPaidPlan: `External Scans is where you can scan any Squarespace webpage outside of the sites you've completed a site audit on. This might be a competitor's webpage, a potential client's webpage, etc. Click "Scan Webpage" to get started`,
  watchTutorialLink: 'https://www.youtube.com/watch?v=Gi7h8fz4dKo',
  watchTutorialLinkPaidPlan:
    'https://www.youtube.com/watch?v=YeYOH9gZVck&list=PLlaoclvOMRPyFA6ylbOSMH3-0Ah3txns4',
  watchTutoial: 'Watch Tutorial (03:35)',
  watchTutoialPaid: 'Watch Tutorial (09:49)',
  seoTaskVideo: 'Unsure Where to Start with SEO/AIO Tasks?',
  freePlanTutorial: 'Free Plan Tutorial (3:35)',
  watchTutorialLinkFreePlan: 'https://www.youtube.com/watch?v=Gi7h8fz4dKo&t=3s'
};

export const sidebarTexts = {
  unlockAllFeatures: 'Unlock All Features!',
  upgradeDesc:
    'Save hours by unlocking site-wide audits and competitor analysis.',
  dismiss: 'Dismiss',
  upgradePlan: 'Upgrade plan',
  trySeo: 'Try SEOSpace',
  trySeoDesc:
    'Get the complete package with all tools for better Squarespace SEO',
  ctaText: 'Try SEOSpace'
};

export const upgradePlanWarnContent = {
  'orbit-ai-agent': {
    title: 'Access Orbit AI!',
    subHeader:
      'Upgrade your plan to unlock AI-powered tools designed to supercharge your SEO strategy.',
    featureList: [
      'Keyword Assist AI suggestions',
      'Content Strategy & Planning',
      'AI Blog Post Agent',
      'Local SEO AI & Review Automation'
    ]
  },
  'keyword-research': {
    title: 'Access Keyword Research!',
    subHeader:
      'Upgrade your plan to find profitable keywords, spy on competitors and track your Google rankings.',
    featureList: [
      'Find profitable keywords',
      'Spy on your competitors',
      'Track rankings for keywords on Google'
    ]
  },
  'seo-tasks': {
    title: 'Access SEO tasks!',
    subHeader:
      'Upgrade your plan to view a prioritised list of SEO tasks to rank higher on Google.',
    featureList: [
      'Prioritized list of SEO tasks',
      'Personalized action plan of where to start',
      'Jargon-free tutorials for each task'
    ]
  },
  'site-audit': {
    title: 'You’ve Ran Out Of Site Audit Slots',
    subHeader:
      'To add a new site, you’ll need to upgrade to unlock additional site audit slots. Alternatively, please delete a site from your dashboard from within “Actions” to add a new one.',
    featureList: [
      'Site-wide SEO score and reports',
      'Peace of mind through automatic monitoring',
      'Squarespace-specific recommendations'
    ]
  }
};

export const upgradePlanWarnContentFree = {
  title: 'Access Site-Wide SEO Audit!',
  subHeader:
    'Upgrade your plan to save hours by scanning your whole site with a click.'
};

// Fallback content if the path does not match any key
export const defaultContent = {
  title: 'Upgrade Your Plan',
  subHeader: 'Upgrade your plan to access premium features.',
  featureList: [
    'Site-wide SEO score and reports',
    'Peace of mind through automatic monitoring',
    'Squarespace-specific recommendations'
  ]
};

export const aiVisibilityContent = {
  featureList: [
    'Track your brand across AI search engines',
    'Full site-wide SEO audit',
    'Actionable SEO tasks & recommendations',
    'Ongoing monitoring'
  ]
};

// Fallback content if the path does not match any key
export const defaultContentSiteAudit = {
  title: 'You’ve Ran Out Of Site Audit Slots',
  subHeader:
    'To add a new site, you’ll need to upgrade to unlock additional site audit slots. Alternatively, please delete a site from your dashboard from within “Actions” to add a new one.',
  featureList: [
    'Site-wide SEO score and reports',
    'Peace of mind through automatic monitoring',
    'Squarespace-specific recommendations'
  ]
};

export const upgradePlanModalTexts = {
  joinWithText: `Join 1000+ SEOSpace users who've already upgraded.`,
  upgradePlan: 'Upgrade Plan',
  contactUs: 'Contact Us'
};

export const helmetTitles = {
  signUpHelmet: 'SEOSpace | Sign Up',
  loginHelmet: 'SEOSpace | Login'
};
export const disconnectedModalTexts = {
  header: 'Reconnect Site',
  desc: 'SEOSpace extension has been disconnected from Squarespace - you can continue auditing your site, but will need go reconnect to access all SEO insights and recommendations.',
  descLocal: `${
    isLocalSeo ? SEOSpaceLocal : 'Local SEO'
  } extension has been disconnected from Squarespace – you can continue managing your business, but you’ll need to reconnect your Google Business account to access complete analytics and performance data.`,
  descOne: ' if you would like to change your subscription.',
  btnText: 'Reconnect Site',
  billing: 'Billing',
  doNotText: 'Do not show this again',
  descNew: 'This has not impacted your billing, please visit '
};

export const signUpTexts = {
  termsConditionDesc:
    'By clicking “Create Account” above, you acknowledge that you have read and agree to the ',
  termsConditionText: 'Terms & Conditions',
  termsConditionLink: 'https://www.seospace.co/terms-and-conditions',
  termsError: 'Please accept SEOSpace’s T&Cs to continue.',
  descTwo:
    'Squarespace websites using SEOSpace are 4 times more likely to get found on Google than the average.'
};

export const termsAndConditionsTexts = {
  title: 'Updated Terms & Conditions',
  desc: 'We have updated SEOSpace’s ',
  descOne: ' - to continue, please press accept.',
  accept: 'Accept',
  contactSupport: 'Contact support',
  contactSupportDesc: ' if you have any queries.'
};

export const statusCheck = {
  desc: "We'll Be Right Back"
};
export const seoChecksTitleObject = {
  'Number of pages that aren’t indexed': "that aren't showing on Google",
  'Images missing alt tags': 'with images missing alt text',
  'Oversized images': 'with oversized images',
  'Pages with missing SEO titles': 'with missing SEO titles',
  'Pages with missing SEO description': 'with missing SEO descriptions',
  'Thin content pages': 'with thin content',
  'Pages with SEO titles too long': 'with SEO titles too long',
  'Pages with SEO titles too short': 'with SEO titles too short',
  'Pages with SEO descriptions too long': 'with SEO descriptions too long',
  'Pages with SEO descriptions too short': 'with SEO descriptions too short',
  'Missing product description': 'missing a product description',
  'Pages without keyword added': 'that haven’t been scanned with a keyword',
  'Keyword not in SEO Title': 'with keyword not in SEO title',
  'Pages with keyword missing in SEO description':
    'with keyword missing in the SEO description',
  'Keyword cannibalization': 'with keyword cannibalization',
  'Pages with broken links': 'with broken links',
  'Keyword not in H1': 'with the target keyword not in the H1'
};

export const primaryEndpoint = [
  API.EndPoint.v2UserDetails,
  API.EndPoint.subscriptionDetailsStripe,
  API.EndPoint.auditCheckersCount,
  API.EndPoint.login,
  API.EndPoint.registration,
  API.EndPoint.checkOut
];

export const errNetworkCodes = ['ERR_NETWORK', 'ERR_CONNECTION_TIMED_OUT'];

export const scannedPagesTexts = {
  scannedPages: 'Scanned Pages',
  learnMore: 'Learn How to Optimize Your Website',
  watchTutorial: 'Watch Tutorial (00:43)',
  desc: 'Below is a list of pages SEOSpace scanned on  '
};

export const blogPostLeavePageModalTexts = {
  title: 'Are you sure you want to leave this page?',
  desc: 'Leaving now will result in losing your progress in generating content ideas.',
  leavePage: 'Leave Page',
  stay: 'Stay'
};

export const blogPostGscPageTexts = {
  title: 'Connect SEOSpace to Google Search Console ',
  desc: 'Connect SEOSpace to Google Search Console to access blog post ideas tailored to your niche and effortlessly generate briefs to fuel your content strategy.',
  watchTutorial: 'Watch Tutorial (09:49)',
  watchTutorialNew: 'Watch Tutorial (04:43)',
  connectGsc: 'Connect to Google Search Console',
  watchTutorialUrl:
    'https://www.youtube.com/watch?v=YeYOH9gZVck&list=PLlaoclvOMRPyFA6ylbOSMH3-0Ah3txns4',
  watchTutorialLatest: 'Watch Tutorial (03:30)'
};
export const seoTasksTexts = {
  updateTask: 'Update tasks list',
  seoMasteryLevel: 'SEO Mastery Levels',
  seoMasteryDesc:
    'Explore the journey to SEO mastery! Remember, SEO is a marathon, not a sprint. Keep climbing and see how your website rise in rankings.',
  beginner: 'Beginner',
  beginnerDesc: 'Complete 5 SEO Tasks/Opportunities to receive Learner level.',
  gscLimitText:
    'Your account has reached the request limit to Google Search Console within 24 hours. Please try this feature later.'
};

export const blogPostNoSitesTexts = {
  title: 'Add a Site to Start Auditing',
  desc: `Add a site to the audit to generate blog post ideas based on your site's content and SEO performance. This will help you create relevant, data-driven content tailored to your audience.`,
  addSite: 'Audit a website'
};

export const siteAuditListsTexts = {
  siteAudit: 'Site Audit',
  desc: 'how would you like to improve your SEO today?',
  siteAuditListItems: [
    // {
    //   text: 'View the top opportunities for my website',
    //   url: paths?.scannedPages,
    //   icons: 'key.svg'
    // },
    {
      text: 'View the highest priority SEO tasks to complete on this website',
      url: paths?.seoTasks,
      icons: 'union.svg',
      setTaskSelected: 'critical'
    },
    {
      text: 'View all SEO tasks and let me decide what to work on',
      url: paths?.seoTasks,
      icons: 'check.svg',
      setTaskSelected: 'all'
    },
    {
      text: 'View the AI visibility dashboard to understand how search and AI tools see this brand',
      url: paths?.aiVisibility,
      icons: 'ai-visibility.svg',
      isNewChip: true
    },
    {
      text: 'See the SEO score of each page on this site, so I can decide where to start',
      url: paths?.scannedPages,
      icons: 'vector.svg'
    },
    {
      text: `Watch a short Squarespace SEO course to level up my knowledge`,
      url: 'https://www.youtube.com/watch?v=XojwGUyQMpA',
      icons: 'file-star.svg'
    }
  ]
};

export const siteAuditDashboardNewBlank = {
  siteAudit: 'Site Audit',
  addSite: 'Add site',
  addYourSite: 'Add Your Site',
  desc: 'Add your Squarespace website to learn how to improve your SEO, with jargon-free recommendations.'
};

export const newSeoTasksTexts = {
  infoBoxTitle: 'Unsure how to fix this?',
  webPages: 'Webpages',
  keywords: 'Keywords',
  reviewDesc:
    'These are keywords your site already shows up for on page one of Google, but not yet in the top three spots. Since most people click one of the first three results, moving up just a few places can bring in a lot more traffic. We highlight keywords that sit in positions 4 to 10, along with the pages that rank for them, so you know exactly where to focus.'
};
export const changePlanTextNew = {
  pricing: 'Pricing',
  pricingDescription:
    'Flexible pricing with no hidden fees — upgrade, downgrade, or cancel whenever it suits you.',
  monthly: 'Monthly',
  billedMonthly: 'Billed monthly',
  billedAnnually: 'Billed annually',
  annually: 'Annually',
  planTimeline: '/mo',
  subscribed: 'Subscribed',
  buySeat: 'Buy Seat',
  planDescription: 'Plan Description',
  saveUptoText: 'Save up to 38%',
  keywordResearchTooltipText:
    'Keyword Research lite gives you data for up to 3 keywords in each search, providing a starting point to find profitable keywords.',
  competitorTooltipText:
    "Competitor Analysis Lite gives limited access to keyword data in each search, providing a snapshot of your competitor's keywords and search engine rankings.",
  flexible: 'Flexible',
  options: 'Options',
  features: 'Features',
  onePrice: 'One Price. ',
  full: 'Full',
  access: 'Access',
  localSeoPricingDesc: 'All features from day one — free for 7 days. ',
  localSeoPricingDescTwo: 'One simple plan. No hidden costs. Cancel anytime.',
  monthsFree: '4 MONTHS FREE'
};

export const noRelatedKeywordHelpTexts = {
  desc: `We couldn’t find any related keywords to your search - this might be because it’s too niche, long (in terms of word count) or no one searches for it. Please search again with a different keyword.`,
  btn: 'Watch Tutorial',
  noBtn: 'Close',
  link: 'https://www.youtube.com/watch?v=Oh93ZVGxQhk'
};

export const buySearchCreditTexts = {
  modalTitle: 'Buy Search Credits',
  desc: 'To access restricted features without upgrading your plan, you can purchase search credits.',
  purchase: 'Purchase',
  footerText:
    'Join 1000+ SEOSpace users who’ve unlocked unrestricted keyword research and gained insights into their competitors’ keywords.',
  bestValue: 'BEST VALUE',
  searchCredit: ' Search Credits',
  oneTime: ' one time',
  infoMessage: 'Payment is proccessing... ',
  footerTextFirst: '35k+ SEO Community',
  footerTextSecond: '100+ Testimonials',
  modalTitleLocalSeo: 'Buy Additional Slots',
  descLocalSeo: `Need more locations? Add extra slots to track and improve your ${
    isLocalSeo ? SEOSpaceLocal : 'Local SEO'
  } performance. Perfect if you serve more than one area or have multiple business locations.`,
  slot: ' Slots'
};
export const starter = 'Starter';
export const starterPlus = 'Starter Plus';
export const diy = 'DIY';
export const pro = 'Pro';
export const DesignerPlanText = 'Designer';
export const AgencyPlanText = 'Agency';
export const expert = 'Expert';
export const expertPlus = 'Expert Plus';
export const proPlus = 'Pro Plus';
export const LocalSEO = 'Local SEO';
export const FreePlanName = 'Free';

export const loginPageTexts = {
  welcomeBack: 'Welcome back',
  desc: 'Please enter your credentials.',
  forgot: 'Forgot Password?',
  notAccount: 'Haven’t got an account?',
  signUp: 'Sign Up'
};
export const massFilterTexts = {
  desc: 'Enter a word or phrase below, and any URLs containing that text will be excluded from the site-wide SEO audit.',
  excludeUrlText: 'Exclude URLs that contain:',
  examplesText: 'Examples: ',
  examplesInputs: '/blog/ /category/',
  selectedToSkip: 'Selected to Skip',
  cancel: 'Cancel',
  apply: 'Apply',
  massSkipPages: 'Skip Multiple Pages',
  requiredToSkip: 'Required to Skip: ',
  notRequiredText: 'You’ve selected enough pages to skip.',
  diySnackBarErrorText:
    'DIY plan users can audit up to 100 pages in their site audit, please select URLs to skip. You can add these back individually via “Actions” once the site audit is complete.',
  proSnackBarErrorText:
    'Pro plan users can audit up to 500 pages in their site audit, please select URLs to skip. You can add these back individually via “Actions” once the site audit is complete.',
  diyTooltipText:
    'With the DIY Plan, you can scan up to 100 pages. Choose which pages to skip to stay within this limit. We recommend skipping pages you don’t want to appear on Google, such as Privacy Policy, Thank You, Blog Collection Pages or temporary pages.',
  proTooltipText:
    'With the Pro Plan, you can scan up to 500 pages. Choose which pages to skip to stay within this limit. We recommend skipping pages you don’t want to appear on Google, such as Privacy Policy, Thank You, Blog Collection Pages or temporary pages.',
  noDataFound: 'No data found'
};

export const signUpToolPageTexts = {
  title: 'The SEO Tool for Squarespace',
  desc: 'Squarespace sites with SEOSpace are ',
  spanText: '4x',
  descOne: ' more likely to get found on Google',
  singUpBg: '/static/images/icons/signupbg-min-crop.png',
  singUpScoreBg: '/static/images/icons/free-audit-bg-img.png',
  footerText: '35,000+ users in 90+ countries',
  scoreFooterText: 'Join 35,000+ Others Using SEOSpace',
  scoreSuggestionDesc: 'Ways to improve your SEO',
  improveSeo: 'Get started with this free SEO Course',
  scoreTitle: "Your Page's SEO Score",
  sqspDesc: 'Squarespace sites with SEOSpace are ',
  sqspDescOne: ' more likely to get found on Google',
  improveSeoLink: 'https://www.youtube.com/watch?v=COofysYPW18',
  localSeoSignUpBg: '/static/images/icons/local-seo-signup-min.png'
};

export const signupTexts = {
  title: 'Create an Account',
  sqspTitle: 'Continue with Squarespace',
  alreadyAccount: 'Already have an account?',
  login: 'Login',
  orText: 'or',
  backToSignUp: 'Back to Sign Up',
  fullScoreTitle: 'Congrats, this page is optimized! ',
  fullScoreDesc:
    'Create an account to audit your whole site and identify how to rank higher on search engines.',
  scoreTitle: 'Create an Account to View Full Report',
  invitationTitle: 'Invitation'
};

export const infoModalTexts = {
  muchMore: '... and much more',
  chargeWarning: 'Your card will be charged immediately with pro-rated amount.',
  billedAnnually: 'Billed annually',
  billedMonthly: 'Billed monthly',
  upgradeSuccessMessage: 'Your plan has been successfully upgraded.',
  downgradeSuccessMessage:
    'Thanks for selecting your new plan - you will have access till the end of the current billing period, and then be automatically downgraded.',
  downgradeFreeSiteText:
    'Note: Downgrading to the free plan will mean you lose all of your site audit data.',
  freeDowngradeDesc:
    "To help us improve SEOSpace, please share some feedback on why you'd like to cancel: ",
  freeLocalSeoDowngradeDesc: `To help us improve ${
    isLocalSeo ? SEOSpaceLocal : 'Local Seo'
  }, please share some feedback on why you'd like to cancel: `,
  continue: 'Continue',
  stayWith: 'Stay with',
  noSelectionError:
    'Your feedback is important to us! Please select a reason for your cancellation to help us improve our service for you and others.',
  otherReasonError:
    'Your feedback is important to us! Please describe a reason for your cancellation to help us improve our service for you and others.',
  missingFeatureError:
    'Your feedback is important to us! Please let us know which features we’re missing to help us improve SEOSpace.',
  missingFeatureLocalSeoError: `Your feedback is important to us! Please let us know which features we’re missing to help us improve ${
    isLocalSeo ? SEOSpaceLocal : 'Local SEO'
  }.`,
  charError: 'Minimum 30 characters required',
  offerSuccess: 'Your offer has been successfully redeemed.',
  deactivateNote:
    'Note: Once your account is deactivated, all your data will be permanently removed from our database.',
  cancelPlanNote:
    'Note: Once you cancel your plan, all your data will be permanently removed from our database.',
  freeDowngradeNote:
    'Note: When your free plan becomes active, all data from your paid plan will be permanently removed from our system.'
};

export const PlanExpiredDialogTexts = {
  mainTitle: 'Choose a Plan to Get Started',
  subtitle:
    "You haven't selected a plan yet. To access the features please choose a plan that fits your needs.",
  memberSubtitle:
    'It looks like your admin hasn’t chosen a plan. Please contact them to get full access to all features.',
  featuresList: [
    'In-depth keyword explorer',
    'Competitors Analysis',
    'Blog post ideas tailored to your niche'
  ],
  buttonText: 'Choose Plan',
  infoTitle: 'Choose Your Plan',
  infoSubTitle:
    'Choose the plan that fits your needs and enjoy the flexibility to pay annually or monthly.',
  planAvailable: 'free plan available',
  resumePlan: 'Resume Plan',
  resumeMainPlan: 'Resume your plan to Get Started',
  declineWarning: 'You must upgrade your plan to maintain access. If you decline, all your data will be permanently lost within 15 days. Are you sure you want to proceed?',
  upgradeRequired: 'Upgrade Required',
  upgradeRequiredDesc: 'Your current plan is Free. To restore full access, please choose an active subscription plan.',
  upgradePlan: 'Upgrade Plan'
};

export const downGradeOfferModalTexts = {
  beforeDownGrade: 'Before You Downgrade...',
  desc: 'We’re excited to offer you this exclusive deal!',
  goBack: 'Go Back',
  noThanks: 'No Thanks, Downgrade',
  claimSpecialOffer: 'Claim Your Special Offer',
  offForThreeMonths: '50% off on next invoice, on us!',
  offForOneMonth: '30% discount for the next 3 invoices, on us!',
  redeemOffer: 'Redeem Offer',
  needBreak:
    'Not using SEOSpace right now? Instead of canceling, pause your subscription for 3 months and pick up right where you left off—no lost progress, no hassle.',
  pauseYourSubScription: 'Pause subscription for 3 months',
  pauseSubscription: 'Pause Subscription',
  experienceBugs:
    'Running into bugs? Get a free month on us while we work on a fix—your feedback helps us improve!',
  receiveFree: '1-month for FREE for sharing your feedback.',
  receiveTwoFree:
    'Receive 2 months FREE and help us improve by providing feedback on a call.',
  hireUsTitle: 'Hiring an expert? Why not hire our expert SEO team?',
  hireUsDesc:
    "We've helped 35,000+ Squarespace websites rank higher, yours could be next.",
  hireUsBtnText: 'Hire Us',
  preferMonthlyDesc: 'Switch to monthly billing of ',
  billedMonthly: 'BILLED MONTHLY',
  beforeDeActivate: 'Before You De-Activate...',
  noThanksDeactivate: 'No Thanks, De-Activate',
  addSevenDays: "Here's a 7-day trial extension, on us!",
  preferMonthlyOffer:
    'Prefer monthly billing? Easily switch to monthly billing using the button below.',
  tooExpensiveOfferDesc:
    'SEO success is about consistency—stay on track and keep seeing results with this special offer.',
  notUsingDesc7Days:
    'Still exploring SEOSpace? Get 7 extra days on your free trial to see how easy SEO can be.',
  switchToMonthly: 'Switch to monthly',
  facingBugsLink:
    'https://calendly.com/rough-water-media/seospace-feedback-call',
  beforeCancel: 'Before You Cancel Subscription...',
  noThanksCancelSub: 'No Thanks, Cancel Subscription'
};

export const previousSearchesTexts = {
  previousSearches: 'Search History',
  previousBlogSearches: 'Blog Idea History',
  previousSearchesKeywordDesc:
    'Below is a list of up to the 10 most recent keyword searches that you have completed. Click on a row to see the results of that search.',
  previousSearchesDesc:
    'Below is a list of up to the 10 most recent competitors you have analyzed. Click on a row to see the results of that analysis.',
  previousSearchDetails: 'Previous Search Details',
  topOrganicKeyword: 'Top Organic Keywords',
  previousSearchesBlogDesc:
    'View your previously generated blog post ideas — up to the last 10. Click on a row to see the full list of suggestions.'
};

export const previousCompetitorAnalysisTableHeadToolTip = [
  'The competitor that was analyzed - click on the row to see what they rank for on Google.',
  'Estimated Traffic - an estimate of how much traffic your competitor gets each month, for each keyword.',
  'Total Keywords - this is the estimated number of keywords this website currently ranks for on Google.',
  'Domain Authority (DA) - DA is a score given to a website that deems how much of an “authority” it is on the internet - the more high quality backlinks, the higher the DA and more likely the site is to rank for competitive keywords.',
  'Backlinks - this shows the number of backlinks this site has. Backlinks are links from other websites to this one - the more high-quality backlinks a website has, the higher its domain authority and chances of ranking for competitive keywords. Quality and quantity is important when it comes to backlinks.',
  'Searched On - date this competitor search was completed on.'
];

export const previousKeywordexplorerTableHeadToolTip = [
  '',
  'Search Volume - this is the total number of people that search for this keyword on Google, per month, in your selected geography.',
  'CPC(cost-per-click) - this is an estimate of how much it would cost to run Google Ads for this keyword per click - a high cost per click indicates a lucrative keyword that advertisers pay a lot for (and likely make a lot of money from!).',
  'Keyword Difficulty - this is an estimate of how competitive it is to rank on page 1 of Google for this keyword out of 100. 0 is very easy, 100 is extremely hard.',
  'Location - the location selected when this keyword was searched. This means that all data shown will be for this specific country.',
  'Searched On - date this keyword search was completed on.'
];

export const previousBlogTableHeadToolTip = [
  'Description - Previously added description',
  'Competiors - Previously added Competiors',
  'Generated On - date this blog post idea search was completed on.'
];

export const GSCConnectSitesListModalTexts = {
  mainTitle: 'Multiple Websites Detected',
  description:
    'We have detected that you have multiple sites in your Google Search Console account that could be the URL you’ve added. Please select one to continue - you can change this later if needed.',
  descriptionTwo: 'if you’re unsure.',
  tutorialLink: 'https://youtu.be/gmXJQa_5POE'
};

export const deleteMultipleRowModalTexts = {
  delete: 'Delete',
  cancel: 'Cancel',
  deleteScan: 'Delete Scan',
  desc: 'Are you sure you want to delete ',
  rows: 'scans?',
  snackBarMessage: ' have been successfully deleted.'
};

export const hostNames = {
  prod: 'app.seospace.co'
};

export const fetchData = 'Please wait while we fetch your data';
export const connectGoogleBusinessProfileBtn =
  'Connect Your Google Business Profile Account';
export const freePlanText = 'Free';
export const freePlanPricingTexts = {
  title: 'Free',
  desc: 'Get started scanning Squarespace pages now',
  btn: 'Get Started',
  amount: '$0.00',
  timeline: '/mo',
  itemList: [
    'Scan Live Squarespace Web Pages',
    'Squarespace SEO Community and Tutorials'
  ]
};

export const folderNameOptions = ['None', 'SEO', 'Other', 'Temp', 'Important'];
//export const folderNameOptions = [];
export const connectAnotherGoogleBusinessProfileAccount =
  'Connect Another Google Business Profile Account';

export const localseoSignup = 'localseo_signup';
export const localseoSignupSqspFlow = 'localseo_signup_sqsp';
//Old local seo signup params
export const localSeoSource = 'localseo';
export const localSeoSignupSource = 'localsignup';
export const localSeoSignupSourceSqsp = 'localseosqsp';
export const localSeoLogo = '/static/images/logo/new-localseo-logo.svg';

export const localSeoConnectTexts = {
  thankYoumessage: 'Thank you for signing up!',
  connectSuccessMessage: 'Please wait while we redirect you to the next steps.'
};

export const cancelSubscriptionText = 'Cancel Subscription';
export const cancelSubscriptionDesc = `We’re sorry to see you go. If there’s anything we could have done better, please let us know. Once your Local SEO plan subscription is canceled, you will still have access to your account, but the Local SEO features will no longer be available.`;
export const enterpriseDropdownSiteLimit = 3;
export const enterpriseDropdownBusinessesLimit = 3;

export const sideBarAllBusinessPath = 'all';
export const sideBarAllBusinessDashBoardPath = 'business-profile';
export const logoutLocalSeoLink = 'https://www.seospace.co/local-seo-tools';

export const localSeoUpgradeCTAText = '7 Day Free Trial';

export const SqSpIconPath = '/static/images/login/Squarespace.svg';
export const SqSpIconTooltipLocalSEOText = `Connected via ${
  isLocalSeo ? SEOSpaceLocal : 'Local SEO'
} extension`;
export const SqSpIconTooltipSEOSpaceText = 'Connected via SEOSpace extension';
export const snackBarSuccessIcon = `/static/images/icons/checkIcon.svg`;
export const planNameCookie = 'planName';
export const technicalError =
  'We’re experiencing a technical issue. Please try again later.';

export const keywordAssist = {
  tutorialText: "Learn How to Use Orbit AI",
  tutorialLink: "https://www.youtube.com/watch?v=NV_1DmzA0yk"
}

export const blogGeneration = {
  tutorialText: "Learn How to Use Blog Generation",
  tutorialLink: "https://www.youtube.com/watch?v=NV_1DmzA0yk"
}

export const localSeoAi = {
  tutorialText: "Learn How to Use Local SEO AI",
  tutorialLink: "https://www.youtube.com/watch?v=NV_1DmzA0yk"
}

export const contentStrategy = {
  tutorialText: "Learn How to Use Content Strategy",
  tutorialLink: "https://www.youtube.com/watch?v=NV_1DmzA0yk"
}